/* eslint-disable @typescript-eslint/no-empty-function */
/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2021-08-27 14:16:43
 */
import {
  CaretDownFilled,
  CaretRightFilled,
  CloseCircleOutlined,
  CloseOutlined,
  EllipsisOutlined,
  ExclamationCircleFilled,
  InfoCircleOutlined,
  PlusOutlined,
  SettingFilled,
  SettingOutlined,
} from '@ant-design/icons'
import DraggableModal from '../DraggableModal'
import { driver } from 'driver.js';
import 'driver.js/dist/driver.css';
import Draggable from 'react-draggable'
import { TabPane } from '../../../compnents/widgets/TabBar'
import AiTreatment from '../aiTreatment'
import { unwrapResult } from '@reduxjs/toolkit'
import {
  Button,
  Checkbox,
  Col,
  Collapse,
  Divider,
  Dropdown,
  Form,
  Input,
  message,
  Modal,
  notification,
  Row,
  Select,
  Space,
  Spin,
  Table,
  Tag,
  Tooltip,
  Typography,
  Tabs,
  Menu,
  Radio,
  Popover,
} from 'antd'
import TextArea from 'antd/lib/input/TextArea'
import { RcFile, UploadFile } from 'antd/lib/upload/interface'
import _ from 'lodash'
import moment from 'moment'
import React, {
  forwardRef,
  ReactElement,
  useCallback,
  useContext,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  selectAppToken,
  selectCredentials,
  selectEdition,
  selectInsuranceArray,
  selectTenantAddress,
  selectTenantAreaCd,
  selectTenantCategory,
  selectTenantCountyCode,
  selectTenantFunction,
  selectTenantName,
  selectUserDepartmentId,
  selectUserId,
  selectUserName,
} from '../../../app/applicationSlice'
import { RootDispatch } from '../../../app/store'
import { DateRangeType, getDateRange } from '../../../compnents/date/TimeSelect'
import FileUpload from '../../../compnents/file/FileUpload'
import {
  AppointmentIcon,
  EditOutlined,
  FemaleFilled,
  LikeedIcon,
  LikeIcon,
  MaleFilled,
  OweMoneyIcon, VoiceAiIcon,
} from '../../../compnents/icons/Icons'
import { DiseaseInput } from '../../../compnents/input/DiseaseInput'
import { Label } from '../../../compnents/widgets/Label'
import { LoadingState } from '../../../models/common'
import { Disease } from '../../../models/disease'
import { PrintTemplateCategory } from '../../../models/print'
import { getRecipeCategoryName, RecipeCategory, RecipeStatus } from '../../../models/recipe'
import { VisitType } from '../../../models/registration'
import { Settings } from '../../../models/setting'
import { TemplateCategory, TemplateDetail } from '../../../models/template'
import {
  getTreatmentCategoryName,
  TreatmentCategories,
  TreatmentCategoriesCQ, TreatmentCategoriesJS,
  TreatmentCategoriesZF,
  TreatmentCategory,
  TreatmentNotice,
} from '../../../models/treatment'
import { Gender, getGenderName } from '../../../models/user'
import { CopyTreatmentParams } from '../../../services/treatment'
import { ThemeContext } from '../../../theme/ThemeContext'
import { useQuery } from '../../../utils/HttpUtils'
import { getAge } from '../../../utils/StringUtils'
import {
  getDoctorsInDepartment,
  getOutpatientDepartments,
  getTenantNurse,
  selectDoctorsInDepartments,
  selectOutpatientDepartments,
  selectTenantNurses,
  getInfectiousDiseaseList,
} from '../../completion/completionSlice'
import { PrintTemplateModal } from '../../print/PrintTemplateModal'
import { UploadModal } from '../../putstorelist/Query/uploadModal'
import {
  searchMedicalAsync,
  selectSearchMedical,
} from '../../registration/register/registerSlice'
import { getRecipeList } from '../../retail/retailSlice'
import { selectBooleanSetting } from '../../settings/settingsSlice'
import { SaveTemplateModal } from '../../template/SaveTemplateModal'
import {
  commonListAsync,
  commonRemoveAsync,
  commonSaveAsync,
  getTempalteDetailList,
  getTemplateCategoryList,
} from '../../template/templateSlice'
import { copyTreatmentRecipe, deleteUploadFileList, getSelectSpecialDiseaseIcd10, getTreatments } from '../diagnosis/diagnosisSlice'
import { ParientInfoRow } from '../diagnosis/parientInfo'
import { PreferencesSetModal } from '../diagnosis/preferencesSetModal'
import { TcmMedicineMaterialColumns } from '../editor/columns'
import {
  getTreatmentNotice,
  setRecipeEditorTreatment,
} from '../editor/recipeListEditorSlice'
import { Treatments, TreatmentsRef } from '../list/Treatments'
import {
  getMedicalRecordsShow,
  getTcmTreatmentOldList,
} from '../list/treatmentSlice'
import { setPatientModalVisible } from '../treatmentSlice'
import { FastInput } from './fastInput'
import { HistoryContent } from './historyContent'
import { HistoryPanel } from './historyPanel'
import { HistoryTitle } from './historyTitle'
import styles from './TcmCases.module.css'
import {
  copyTreatment,
  createTreatment,
  getTreatment,
  resetTcmCase,
  selectRegistration,
  selectTreatmentT,
  selectTreatmentCreatingState,
  setTreatmentCreatingState,
  startTreatment,
  defaultMainComplaintListAsync,
  getUrl,
} from './tcmCasesSlice'
import {HydGPTRun} from "../../../utils/HydGPT";
import AILoading from "../../../layouts/img/ailoading.gif";
import {selectInsuranceItem, setInsurance} from "../../../layouts/insuranceSlice";
import {DateTimeFormat, DateTimeFormatSimpleOnlyOne} from "../../../models/datetime";
import AiAgreement from "../AiAgreement";
import { useForm } from 'antd/lib/form/Form';
import { selectSettings } from '../../user/setting/settingSlice'
import { Patient } from '../../../models/patient'
import {getPatientDetail, getVoiceAiTreatment} from '../../patient/patientSlice'
import { ReplenishPatientModal } from '../editor/modals/lxbxsPatientModal'
import { CopyRecipeParams } from '../../../services/recipe'
import { getUserProfileList, getUserProfileListMessage } from '../../personalManagement/personalDetail/personalDetailSlice'
import { traceRoute } from '../../../layouts/layoutSlice';
import { HistoricalEpidemiologyFastInput } from '../editor/components/HistoricalEpidemiologyFastInput';
import { InfectiousDisease } from '../../../services/disease'
import XfyunRTASRSimpleLLM, {XfyunRTASRRef} from "../../soundMedical/XfyunRTASRSimpleLLM";
const { Text } = Typography

export interface TcmcaseRef {
  submit: () => Promise<void>
  showTreatments: () => void
}

interface TcmCasesProps {
  readMode?: boolean
  state?: number
  saveEdit?: () => void
  registrations?: any
  owelabel?: any
  oweMoneyNum?: any
  oweMoneyShow?: any
  insuranceBean?: any
  patientInsurance?: any
  PreferencesSetChange?: () => void
}

const TcmCases = (
  {
    readMode = false,
    state = undefined,
    saveEdit = () => {},
    registrations,
    owelabel,
    oweMoneyNum,
    oweMoneyShow,
    insuranceBean,
    patientInsurance,
    PreferencesSetChange,
  }: TcmCasesProps,
  ref: React.Ref<TcmcaseRef>
) => {
  const layout = {
    labelCol: { flex: '4rem' },
    wrapperCol: { flex: 1 },
  }

  const columnLayout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 18 },
  }
  
  const { CheckableTag } = Tag

  const { Option } = Select

  const { Panel } = Collapse
  const [aiLargeVisible, setAiLargeVisible] = useState(false)

  const [restoreFlag,setRestoreFlag] = useState(false)

  const [recipeItemToConclusionLoading, setRecipeItemToConclusionLoading] = useState(false)

  const patientSystolicPressureRef = useRef<any>(null)

  const patientDiastolicPressureRef = useRef<any>(null)

  const patientPulseRef = useRef<any>(null)

  const patientHeightRef = useRef<any>(null)

  const patientWeightRef = useRef<any>(null)

  const theme = useContext(ThemeContext)

  const query = useQuery()

  const [form] = useForm()

  const dispatch = useDispatch<RootDispatch>()
  const tenantCountyCode = useSelector(selectTenantCountyCode)

  const treatmentsRef = useRef<TreatmentsRef>(null)

  const [TcmCasesForm] = Form.useForm()

  // const [patientForm] = Form.useForm()

  const [treatmentForm] = Form.useForm()
  
  const settings = useSelector(selectSettings)

  const [patient, setPatient] = useState<Patient | undefined>()

  const lxbxsFlag = settings?.[105]?.includes('1101') // 初版 蚊媒传染病版本

  const lxbxsNewFlag = settings?.[105]?.includes('1102') //新版 各项流行病学史齐全

  const [patientSystolicPressureValue, setPatientSystolicPressureValue] = useState<any>()

  const [patientDiastolicPressureValue, setPatientDiastolicPressureValue] = useState<any>()

  const [templateKeyword, setTemplateKeyword] = useState('')

  const [isDoctorEditable, setIsDoctorEditable] = useState(!readMode)

  const [isDiseaseEditable, setIsDiseaseEditable] = useState(true)

  const [isDiseaseEmpty, setIsDiseaseEmpty] = useState(false)

  const [isLookPicModalVisible, setIsLookPicModalVisible] = useState(false)

  const [lookPic, setLookPic] = useState('')

  const [fileList, setFileList] = useState<UploadFile[]>([])

  const [isUploadVisible, setIsUploadVisible] = useState(false) //上传附件弹窗

  const [isOpen, setIsOpen] = useState(false)

  const [mlBtnLoading, setmlBtnLoading] = useState(false)
  const [cfBtnLoading, setcfBtnLoading] = useState(false)
  const [kcBtnLoading, setkcBtnLoading] = useState(false)

  const [templates, setTemplates] = useState<TemplateCategory[]>([])

  const [isModalVisible, setIsModalVisible] = useState(false)

  const [copyRecipeFlag, setCopyRecipeFlag] = useState<any>(false)

  const [selectedDiseases, setSelectedDiseases] = useState<Disease[]>([])

  // 传染病列表缓存
  const [infectiousDiseaseList, setInfectiousDiseaseList] = useState<InfectiousDisease[]>([])

  const [isPrintModalVisible, setIsPrintModalVisible] = useState(false)

  const [printLoading, setPrintLoading] = useState(false)

  const credentials = useSelector(selectCredentials)

  const hisVersion = useSelector(selectEdition) //his版本 0通用 1口腔

  const doctors = useSelector(selectDoctorsInDepartments)

  const nurses = useSelector(selectTenantNurses)

  const creatingState = useSelector(selectTreatmentCreatingState)

  const registration = useSelector(selectRegistration)

  const searchMedical = useSelector(selectSearchMedical)

  const treatment = useSelector(selectTreatmentT)
  const departments = useSelector(selectOutpatientDepartments)
  const tenantCategory = useSelector(selectTenantCategory)
  const baseData = useSelector(selectInsuranceItem)

  const [templateDetails, setTemplateDetails] = useState<
    Record<string, any[]>
  >({})

  const [targetTemplate, setTargetTemplate] = useState<any>(undefined)

  const [isCopyReciptModalVisible, setIsCopyReciptModalVisible] = useState(
    false
  )

  const [isCopyReciptParam, setIsCopyReciptParam] = useState<any>()

  const doNotWarnDoctorMismatch = useSelector(
    selectBooleanSetting(Settings.Treatment.DoNotWarnDoctorMismatch)
  )

  const [isCreating, setIsCreating] = useState(false)

  const registrationId = query.get('registrationId') as string

  const treatmentId = query.get('treatmentId') as string

  const [notice, setNotice] = useState<TreatmentNotice | undefined>()

  const [tempType, setTempType] = useState(false)

  const [selectedCategoryId, setSelectedCategoryId] = useState('')

  const [SaveTemplateModalVasible, setSaveTemplateModalVasible] = useState(
    false
  )

  const [isReplenishPatientModalVisible, setIsReplenishPatientModalVisible] = useState(false)

  const [isTipsModalVisible, setIsTipsModalVisible] = useState<any>()

  const [seeOtherDoctor, setSeeOtherDoctor] = useState(true)

  const [historyList, setHistoryList] = useState<any>([])

  const [historyData, setHistoryData] = useState<any>({})

  const [CollapseActivekey, setCollapseActivekey] = useState('0')

  const [recipeCollapse, setRecipeCollapse] = useState<any>([])

  const [reuseType, setReuseType] = useState(false)

  const [reuseTreatmentId, setReuseTreatmentId] = useState('')

  const [preferencesSetShow, setiPreferencesSetShow] = useState(false) //偏好设置

  const [loading, setLoading] = useState(false)

  const [deleteFlag, setDeleteFlag] = useState<any>(false)

  const departmentId = useSelector(selectUserDepartmentId)

  const [aiBtnText,setAiBtnText] = useState('')

  const [submitFlag, setSubmitFlag] = useState(false)

  const [aiPlusText,setAiPlusText] = useState('')
  const insuranceArray = useSelector(selectInsuranceArray)
  const userName = useSelector(selectUserName)

  const userId = useSelector(selectUserId)

  const tenantAddress = useSelector(selectTenantAddress)

  const tenantAreaCd = useSelector(selectTenantAreaCd)

  const tenantName = useSelector(selectTenantName)

  const cycleCode = sessionStorage.getItem('cycleCode')

  const [aicheckDone, setAicheckDone] = useState(true)

  const [settledState, setSettledState] = useState(false)

  interface AiMessage {
    role: string;
    content: string;
  }
  const [aiMsg, setAiMsg] = useState<AiMessage[]>([]);

  const token = useSelector(selectAppToken)

  const aiSwitch = useSelector(
      selectBooleanSetting(Settings.AI.MAIN_SWITCH)
  )
  const aiVoice = useSelector(selectBooleanSetting(Settings.AI.VOICE_AI_SWITCH))

  // 控制悬浮组件的显示/隐藏
  const [showVoiceFloat, setShowVoiceFloat] = useState(false);
  // 绑定组件ref，用于外部控制停止录音
  const voiceRef = useRef<XfyunRTASRRef>(null);
  const [speakTextArray, setSpeakTextArray] = useState<any>([])
  const [voiceAiLoading, setVoiceAiLoading] = useState(false)

  const voiceAiLoadingRef = useRef(false);

  // 监听状态变化，同步更新ref（核心：让ref始终和状态保持一致）
  useEffect(() => {
    voiceAiLoadingRef.current = voiceAiLoading;
  }, [voiceAiLoading]);

  const [activeDropdown, setActiveDropdown] = useState<string | null>(null);

  const [inputValues, setInputValues] = useState<Record<string, string>>({});

  const [inputIcds, setInputIcds] =useState<Record<string, string>>({});

  const [diseaseOptions, setDiseaseOptions] = useState<any>()
  const infectiousCheck: any = useSelector(selectTenantFunction)

  const handleOptionSelect = (icds: string, disName:any,disIcds?: any) => {
    setInputValues(prev => ({
      ...prev,
      [icds]: disName
    }));
    setInputIcds(prev => ({
      ...prev,
      [icds]: disIcds
    }));
  }

  const getDiseaseList = (diseaseCode: any, diseaseName?: any) => {
    dispatch(
      getSelectSpecialDiseaseIcd10({
        diseaseCode: diseaseCode,
        cbxz: patientInsurance?.cbxz,
        diseaseName: diseaseName 
      })
    )
      .then(unwrapResult)
      .then((v: any) => {
        setDiseaseOptions({
          ...diseaseOptions,
          [diseaseCode]: v,
        })
      })
  }
  
  useEffect(() => {
    setDeleteFlag(false)
    setAiBtnText("AI写病历")
    setCopyRecipeFlag(false)
    setSubmitFlag(false)
  }, [])


  // 获取传染病列表
  useEffect(() => {
    const needCheck = infectiousCheck?.[105] === '1101' || infectiousCheck?.[105] === '1102';
    if (needCheck) {
      dispatch(getInfectiousDiseaseList())
        .then(unwrapResult)
        .then((data) => {
          setInfectiousDiseaseList(data)
        })
        .catch(() => {
          // 接口失败不影响主流程
        })
    }
  }, [dispatch, infectiousCheck])

  useEffect(() => {
    const historyPanelCheck = localStorage.getItem('historyPanelCheck')
    setSeeOtherDoctor(historyPanelCheck == 'true' ? true : false)
  }, [])

  // 获取个人设置权限
   useEffect(() => {
     if (userId) {
       setPageLoading(true)
       dispatch(getUserProfileListMessage({ userId: userId ,flag:1}))
         .then(unwrapResult)
         .then((v: any) => {
           const records = v?.records || []
           const functionsFieldConfig = v?.functionsFieldConfig?.filter((t: any) => t?.templateType === 'ZYBL')?.[0]?.fields?.filter((j:any)=>j?.isVisible)
           setCheckData(records)
           setFunctionsFieldConfig([
             ...functionsFieldConfig?.slice(0, 2),
             { key: 'lxbsContent', label: '流行病学史' },
             ...functionsFieldConfig?.slice(2, functionsFieldConfig?.length),
           ])
         })
         .finally(() => {
           setPageLoading(false)
         })
     }
   }, [userId])
  const [checkData, setCheckData] = useState<any>([])
  
  const [functionsFieldConfig, setFunctionsFieldConfig] = useState<any[]>([])
  
  const [pageLoading, setPageLoading] = useState(false)
  
  const isWubi = checkData?.filter((v: any) => v?.code == '5')?.[0]?.codeName == 1 ? 1 : 0 

  const storedepartmentId =
    localStorage.getItem('registrationDepartmentId') || departmentId

  const submit = async (notSaveEditFlag?:any,isNotModifySign?: any, saveFlag?: any, printFlag?: any) => {
    setSubmitFlag(true)
    const treatmentValues = await treatmentForm.validateFields()
    console.log(treatmentValues, doctors, doctors?.find((v) => v?.id == treatmentValues?.treatmentDoctorId)?.name, "获取医生字段，不要删掉");
    if (!doctors?.find((v) => v?.id == treatmentValues?.treatmentDoctorId)?.name) {
      notification.info({
        message: '该科室下找不到该医生，如需修改病历，请先修改接诊的科室/医生'
      })
      return
    }
      if (creatingState === LoadingState.Loading) {
        return
      }
      if (selectedDiseases.length === 0) {
        setIsDiseaseEmpty(true)
      }
      try {
      const diagnosisValues = await TcmCasesForm.validateFields()
      // const patientValues = await patientForm.validateFields()
      const treatmentValues = await treatmentForm.validateFields()
      const newTreatment = {
        ...diagnosisValues,
        // ...patientValues,
        ...treatmentValues,
        id: treatment?.id,
        medicalRecord: 2,
        registrationId: registration?.id || registrationId,
        patientId: registration?.patientId,
        receiveTag: reuseType ? VisitType.Subsequence : VisitType.First,
        disease: selectedDiseases.map((d) => `${d.name}/${d.icds}`).join(','),
        treatmentDepartmentName: departments.find(
          (d) => d.id === treatmentValues.treatmentDepartmentId
        )?.name,
        treatmentDoctorName: doctors.find(
          (d) => d.id === treatmentValues.treatmentDoctorId
        )?.name,
        treatmentNurseName: nurses.find(
          (n) => n.id === treatmentValues.treatmentNurseId
        )?.name,
        infectiousDisease: treatmentValues.infectiousDisease ? 1 : 0,
        personalHistory: diagnosisValues.personalHistoryEnable
          ? diagnosisValues.personalHistory
          : '',
        familyHistory: diagnosisValues.familyHistoryEnable
          ? diagnosisValues.familyHistory
          : '',
        vaccineHistory: diagnosisValues.vaccineHistoryEnable
          ? diagnosisValues.vaccineHistory
          : '',
        menstrualHistory: diagnosisValues.menstrualHistoryEnable
          ? diagnosisValues.menstrualHistory
          : '',
        maritalHistory: diagnosisValues.maritalHistoryEnable
          ? diagnosisValues.maritalHistory
          : '',
        diseaseType: '3',
        insuranceCode: registration?.insuranceCode,
        reuseTreatmentId: reuseTreatmentId || undefined,
        coherentVideo: fileList
          .map((v) => `${v.name}@${v.uid}@`.concat(v.url || ''))
          .join(','),
      }
      setIsCreating(true)
      dispatch(setTreatmentCreatingState(LoadingState.Loading))
      // if (selectedDiseases.length) {
      // isNotModifySign点击诊断书打印标志位 如果是诊断书保存时多传一个参数
      const paramsData = isNotModifySign
        ? { ...newTreatment, isNotModifySign: true }
        : { ...newTreatment }
          await dispatch(createTreatment(paramsData))
            .then(unwrapResult)
            .then(() => {
              notification.success({ message: '保存成功' })
              getRefreshList(registrationId, treatmentId)
            })
            .finally(()=>{
              setIsCreating(false)
              if (saveFlag == 1) {
                if (query.get('cfcxFlag')) {
                  dispatch(
                    traceRoute({
                      name: '医生工作站',
                      path: '/doctor/station',
                      state: {
                        station: query.get('station'),
                      },
                    })
                  )
                } else if (query.get('wpcfFlag')) {
                  dispatch(
                    traceRoute({
                      name: '外配处方',
                      path: '/outRecipe',
                      state: {
                        backSelectTab: '2'
                      }
                    })
                  )
                } else if (query.get('kskdFlag')) {
                  dispatch(
                    traceRoute({
                      name: credentials?.isAskMedicine == 1
                        ? '处方申请'
                        : '快速开单',
                      path: '/retail',
                    })
                  )
                } else if (query.get('ydkdFlag')) {
                  dispatch(
                    traceRoute({
                      name: '药店开单',
                      path: '/pharmacy/retail',
                    })
                  )
                } else {
                  dispatch(
                    traceRoute({
                      name: '医生门诊',
                      path: '/patients',
                    })
                  )
                }
                return
              } else {
                if (notSaveEditFlag) {
                  return
                } else {
                  saveEdit()
                }
              }
            })
      // } else {
      // notification.error({ message: '中医诊断不能为空' })
      // }
      } catch (e) {
        return Promise.reject(e)
      } finally {
      dispatch(setTreatmentCreatingState(LoadingState.Finished))
      }
      return Promise.resolve()
    // }
  }

  useImperativeHandle(ref, () => ({
    submit: () => submit(),
    validateFields: () => {
      setSubmitFlag(true)
      return TcmCasesForm.validateFields()
    },
    showTreatments: () => setIsModalVisible(true),
  }))

  useEffect(() => {
    if (nurses.length == 0) {
      dispatch(getTenantNurse(storedepartmentId))
    }
  }, [])

  useEffect(() => {
    dispatch(getOutpatientDepartments())
  }, [dispatch])

  useEffect(() => {
    registrationId &&
      dispatch(searchMedicalAsync({ registrationId: registrationId }))
        .then(unwrapResult)
        .then((v) => {
          if (v?.length) {
            if (v?.[0]?.medicalRecord == 2 && v?.[0]?.localDisease) {
              setIsTipsModalVisible(false)
            } else {
              setIsTipsModalVisible(true)
            }
          }
        })
    registration?.receiveTag && setReuseType(registration.receiveTag == 1) //复诊是否勾选
  }, [registration])

  useEffect(() => {
    if (isTipsModalVisible && searchMedical?.length) {
      const result = searchMedical.reduce((obj: any, item: any) => {
        obj[item.diseaseCode] = `${item.diagName?.split('/')?.[0]}`
        return obj
      }, {})
      const resultIcds = searchMedical.reduce((obj: any, item: any) => {
        obj[item.diseaseCode] = item.diagCode
        return obj
      }, {})
      setInputValues(result)
      setInputIcds(resultIcds)

      searchMedical?.map((v:any)=>{
        form.setFieldsValue({
          [`diagnosis-${v.diseaseCode}`]: v?.diagName
        })
      })
    }
  }, [isTipsModalVisible, searchMedical])

  useEffect(() =>{
    if(!registration || registration == null ){
      return
    }
    const insuranceItem = insuranceArray.find(
      (v) => v.insuranceCode === registration?.insuranceCode
    )
    if (insuranceItem && JSON.stringify(insuranceItem) !== '{}') {
      dispatch(
        setInsurance({
          ...insuranceItem,
          userName,
          userId,
          cycleCode,
          tenantCategory,
          tenantAreaCd,
          name: tenantName,
          address: tenantAddress,
          areaCode: tenantAreaCd,
          endTime: moment(insuranceItem.endTime).format(
            DateTimeFormatSimpleOnlyOne
          ),
        })
      )
    }
  },[registration])

  useEffect(() => {
    if (!registration?.patientId || !registration?.id) {
      return 
    }else{
   
    dispatch(getTreatmentNotice(registration.patientId))
      .then(unwrapResult)
      .then((notice) => setNotice(notice))
      .catch(() => {
        // do nothing
      })
    dispatch(getMedicalRecordsShow({ patientId: registration?.patientId,registrationId : registration?.id}))
      .then(unwrapResult) //历史信息回显
      .then((res: any) => {
        // 解决闪烁问题
        TcmCasesForm.setFieldsValue({
          ...res,
          historyOfPresentIllness:
            TcmCasesForm.getFieldValue('historyOfPresentIllness') ||
            res?.historyOfPresentIllness,
          pastMedicalHistory:
            TcmCasesForm.getFieldValue('pastMedicalHistory') ||
            res?.pastMedicalHistory,
          allergen: TcmCasesForm.getFieldValue('allergen') || res?.allergen,
          personalHistory:
            TcmCasesForm.getFieldValue('personalHistory') ||
            res.personalHistory,
          familyHistory:
            TcmCasesForm.getFieldValue('familyHistory') || res.familyHistory,
          vaccineHistory:
            TcmCasesForm.getFieldValue('vaccineHistory') || res.vaccineHistory,
          menstrualHistory:
            TcmCasesForm.getFieldValue('menstrualHistory') ||
            res.menstrualHistory,
          maritalHistory:
            TcmCasesForm.getFieldValue('maritalHistory') || res.maritalHistory,
            personalHistoryEnable: TcmCasesForm.getFieldValue('personalHistoryEnable') || !!res.personalHistory,
            familyHistoryEnable: TcmCasesForm.getFieldValue('familyHistoryEnable') ||!!res.familyHistory,
            vaccineHistoryEnable: TcmCasesForm.getFieldValue('vaccineHistoryEnable') || !!res.vaccineHistory,
            menstrualHistoryEnable: TcmCasesForm.getFieldValue('menstrualHistoryEnable') || !!res.menstrualHistory,
            maritalHistoryEnable: TcmCasesForm.getFieldValue('maritalHistoryEnable') ||!!res.maritalHistory,
          coherentVideo: fileList
            .map((v) => `${v.name}@${v.uid}@`.concat(v.url || ''))
            .join(','),
        })
      })
    }
  }, [registration])

  useEffect(() => {
    dispatch(setRecipeEditorTreatment(treatment))
    treatmentForm.setFieldsValue({
      treatmentNurseId:
        Number(treatment?.treatmentNurseId) > -1
          ? treatment?.treatmentNurseId?.toString()
          : undefined,
    })
  }, [treatment])
  
  useEffect(() => {
    if (treatment?.id) {
      dispatch(getRecipeList(treatment?.id))
        .then(unwrapResult)
        .then((recipes: any) => {
          const itemList = recipes?.filter((v: any) => {
            return v?.state == RecipeStatus.Settled
          })
          const SettledState = recipes?.length ? itemList?.length == recipes?.length ? true : false : false
          setSettledState(SettledState)
        })
        .catch(() => {
          // do nothing.
        })
    }
  }, [treatment?.id])

  useEffect(() => {
    getRefreshList( registrationId, treatmentId)
    if (!readMode) {
      dispatch(startTreatment(registrationId))
    }
  }, [dispatch, registrationId, treatmentId])

  useEffect(() => {
    if (registration) {
      if (registration.treatmentDepartmentId) {
        dispatch(getDoctorsInDepartment(registration.treatmentDepartmentId))
      }
      const flag = doctors?.find(
        (d) =>
          d.id ==
          (registration.treatmentDoctorId || registration.registrationDoctorId)
      )
      treatmentForm.setFieldsValue({
        registrationDoctorName:
          registration.treatmentDoctorName ||
          registration.registrationDoctorName,
        treatmentDepartmentId:
          registration.treatmentDepartmentId == '0'
            ? undefined
            : registration.treatmentDepartmentId || storedepartmentId,
        treatmentDoctorId:
          registration.treatmentDoctorId == '0'
            ? undefined 
            : flag ? (registration.treatmentDoctorId ||
              registration.registrationDoctorId) : registration.treatmentDoctorName,
        // receiveTag: registration.receiveTag === VisitType.Subsequence,
      })
      
      if (
        registration.treatmentDepartmentId == '0' &&
        registration.treatmentDoctorId == '0'
      ) {
        Modal.warn({
          title: '提示',
          content: '暂未指定医生，请先选择接诊医生再填写病历',
        })
      }
      if (!treatment) {
        const defaultCategory = (tenantCountyCode?.indexOf("3307")== 0 && registrations?.insuranceCode !== 'ZIFEI') ? TreatmentCategory.GeZhang : TreatmentCategory.Normal;
        treatmentForm.setFieldsValue({
          treatmentCategory: defaultCategory,
        })
      }
    }
  }, [dispatch, registration?.registrationDoctorId])

  useEffect(() => {
    if (registration) {
       const flag = doctors?.find(
        (d) =>
          d.id ==
          (registration.treatmentDoctorId || registration.registrationDoctorId)
      )
      treatmentForm.setFieldsValue({
        treatmentDoctorId:
          registration.treatmentDoctorId == '0' 
            ? undefined 
            : flag ? (registration.treatmentDoctorId ||
              registration.registrationDoctorId) : registration.treatmentDoctorName,
      })
    }
  }, [registration?.treatmentDepartmentId,doctors])

  const treatmentCategoryChose = (key: number) => {
    if (!searchMedical) return
    switch (key) {
      case 0:
        // setIsOpen(false)
        setSelectedDiseases((selectedDiseases) => {
          return selectedDiseases?.filter((v) => {
            if (
              searchMedical?.find((item: any) => v?.icds == item?.diseaseCode)
            ) {
              notification.warn({
                message: (
                  <span>
                    不允许同时添加普通病与特慢病
                    <br></br>
                    已为您删除特慢病{v.name}
                  </span>
                ),
                duration: 3,
              })
            }
            if (
              searchMedical?.findIndex(
                (item: any) => v.icds == item.diseaseCode
              ) < 0
            ) {
              return v
            } else {
              return
            }
          })
        })
        break
      case 1:
      case 2:
        // setIsOpen(true)
        setSelectedDiseases((selectedDiseases) => {
          return selectedDiseases?.filter((v) => {
            if (
              !searchMedical?.find((item: any) => v?.icds == item?.diseaseCode)
            ) {
              notification.warn({
                message: (
                  <span>
                    不允许同时添加普通病与特慢病
                    <br></br>
                    已为您删除普通疾病{v.name}
                  </span>
                ),
                duration: 3,
              })
            }
            return searchMedical?.find(
              (item: any) => v.icds == item.diseaseCode
            )
          })
        })

        break
      default:
        break
    }
  }

  useEffect(() => {
    dispatch(getDoctorsInDepartment(storedepartmentId))
  }, [storedepartmentId])

 const mergeUniqueArrays=(baseArray:any, newArray:any) =>{
  const icdsSet = new Set(baseArray.map((item:any) => item.icds));
  const uniqueItems = newArray.filter((item:any) => !icdsSet.has(item.icds));
  return [...baseArray, ...uniqueItems];
}

  const diseasesChose = (v: any) => {
    switch (v.diseTypeCode) {
      case '12':
        TcmCasesForm.setFieldsValue({
          treatmentCategory: TreatmentCategory.Special,
        })
        // setTimeout(() => {
        //   treatmentCategoryChose(1)
        // }, 1000)
        break
      case '11':
        TcmCasesForm.setFieldsValue({
          treatmentCategory: TreatmentCategory.Slow,
        })
        // setTimeout(() => {
        //   treatmentCategoryChose(2)
        // }, 1000)
        break
      case '14':
        TcmCasesForm.setFieldsValue({
          treatmentCategory: TreatmentCategory.SlowAndSpecial,
        })
        // setTimeout(() => {
        //   treatmentCategoryChose(2)
        // }, 1000)
        break
      default:
        // if (
        //   TcmCasesForm.getFieldValue('treatmentCategory') ==
        //     TreatmentCategory.Special ||
        //   TcmCasesForm.getFieldValue('treatmentCategory') ==
        //     TreatmentCategory.Slow ||
        //   TcmCasesForm.getFieldValue('treatmentCategory') ==
        //     TreatmentCategory.SlowAndSpecial
        // ) {
        //   TcmCasesForm.setFieldsValue({
        //     treatmentCategory: TreatmentCategory.Normal,
        //   })
        // }
        TcmCasesForm.resetFields(['disease'])
        // setTimeout(() => {
        //   treatmentCategoryChose(0)
        // }, 1000)
        break
    }
  }
  useEffect(() => {
    if (!treatment) {
      setIsDiseaseEditable(true)
      return
    }
    if (treatment?.disease) {
      if (readMode) {
        setIsDiseaseEditable(false)
      }
      setSelectedDiseases(
        treatment?.disease
          .split(',')
          .map((d:any) => d.split('/'))
          .map((pair:any) => ({ name: pair[0], icds: pair[1] } as Disease))
      )
      setIsDiseaseEmpty(false)
    } else {
      setSelectedDiseases([])
    }
    TcmCasesForm.setFieldsValue({
      ...treatment,
      disease: '',
      allergen: TcmCasesForm.getFieldValue('allergen') || treatment.allergen ,
      personalHistoryEnable: !!treatment.personalHistory,
      familyHistoryEnable: !!treatment.familyHistory,   
      vaccineHistoryEnable: !!treatment.vaccineHistory,
      menstrualHistoryEnable: !!treatment.menstrualHistory,
      maritalHistoryEnable: !!treatment.maritalHistory,
      infectiousDisease: treatment.infectiousDisease === 1,
    })
    getPatientDetailData()
    if (treatment?.patientWeight && treatment?.patientHeight) {
      const BMI = (
        (treatment?.patientWeight /
          (treatment?.patientHeight * treatment?.patientHeight)) *
        10000
      ).toFixed(1)
      TcmCasesForm.setFieldsValue({
        BMI,
      })
    }
    // patientForm.setFieldsValue({
    //   patientId: treatment?.patientId,
    //   patientHeight: treatment?.patientHeight,
    //   patientName: registration?.patientName,
    //   patientPhone: registration?.patientPhone,
    //   patientPulse: treatment?.patientPulse,
    //   patientSex: registration?.patientSex,
    //   patientSystolicPressure: treatment?.patientSystolicPressure,
    //   patientDiastolicPressure: treatment?.patientDiastolicPressure,
    //   patientTemperature: treatment?.patientTemperature,
    //   patientWeight: treatment?.patientWeight,
    // })
    treatmentForm.setFieldsValue({
      treatmentCategory:
        treatment.treatmentCategory == 0 || treatment.treatmentCategory == -1
          ? TreatmentCategory.Normal
          : treatment.treatmentCategory || TreatmentCategory.Normal,
      // infectiousDisease: treatment.infectiousDisease === 1,
    })
    setReuseType(reuseType || treatment.receiveTag === VisitType.Subsequence)
    setReuseTreatmentId(reuseTreatmentId || treatment?.reuseTreatmentId || '')
    // if (treatment.receiveTag !== undefined) {
    //   treatmentForm.setFieldsValue({
    //     receiveTag: treatment.receiveTag === VisitType.Subsequence,
    //   })
    // }
    if (readMode) {
      setIsDoctorEditable(
        treatment.treatmentDepartmentId === '0' ||
          treatment.treatmentDoctorId === '0'
      )
      if (!registration?.treatmentDoctorId && treatment.treatmentDoctorId) {
        dispatch(getDoctorsInDepartment(treatment.treatmentDepartmentId))
      }
      const flag = doctors?.find(
        (d) =>
          d.id ==
          (treatment.treatmentDoctorId === '0'
          ? undefined
          : treatment.treatmentDoctorId)
      )
      if (
        !registration?.registrationDepartmentId &&
        !registration?.treatmentDoctorId
      ) {
        const doctorName = doctors.find(
          (d) =>
            d.id ===
            (treatment.treatmentDoctorId === '0'
              ? undefined
              : treatment.treatmentDoctorId)
        )?.name
        treatmentForm.setFieldsValue({
          treatmentDepartmentId:
            treatment.treatmentDepartmentId === '0'
              ? undefined
              : treatment.treatmentDepartmentId,
          treatmentDoctorId:
            treatment.treatmentDoctorId === '0' 
              ? undefined
              : treatment.treatmentDoctorId,
        })
      }
    }
    treatment.coherentVideo
      ? setFileList(
          treatment.coherentVideo.split(',').map((v:any) => {
            return ({
              name: v.split('@')[0],
              uid: v.split('@')[1] ? v.split('@')[1] : v.split('@')[0],
              url: v.split('@')[2] ? v.split('@')[2] : v.split('@')[0],
            } as unknown) as UploadFile
          })
        )
      : setFileList([])
  }, [treatment])

  useEffect(() => {
    if (templateKeyword) {
      if (templates?.length) {
        const ids: any = templates?.map((v) => {
          return v?.id
        })
        setRecipeCollapse(ids)
      }
    } else {
      setRecipeCollapse([])
    }
  }, [templateKeyword, templates])

  useEffect(() => {
    if (recipeCollapse?.length > 1)
      _.forEach(recipeCollapse, (id) => {
        if (!templateDetails[id]) {
          const template = templates.find((t) => t.id === id)
          setSelectedCategoryId(id)
          if (template) {
            dispatch(getTempalteDetailList(id))
              .then(unwrapResult)
              .then((details) => {
                setTemplateDetails({
                  ...templateDetails,
                  [id]: details,
                })
              })
          }
        }
      })
  }, [recipeCollapse])

  useEffect(() => {
    dispatch(
      getTemplateCategoryList({
        current: 1,
        size: 100,
        categoryName: templateKeyword,
        medicalRecord: 2,
        isWubi: isWubi,
      })
    )
      .then(unwrapResult)
      .then(async (templates) => {
        let activeId = '0'
        setTemplates([
          {
            categoryName: '收藏',
            id: '-1',
            medicalRecord: 2,
          },
          ...templates,
        ])
        // setTemplates([...templates])
        const commonList = !templateDetails['-1']
          ? await dispatch(commonListAsync('2')).then(unwrapResult)
          : templateDetails['-1']
        if (commonList.length && !templateDetails['-1']) {
          activeId = '-1'
        } else {
          activeId = templates[0].id
        }
        templates.length && setSelectedCategoryId(activeId)
        // const collArr = Array.from(new Set([activeId, templates[0]?.id]))
        // setRecipeCollapse(collArr)
        _.forEach([templates[0]?.id], (id) => {
          if (!templateDetails[id]) {
            const template = templates.find((t) => t.id === id)
            if (template) {
              dispatch(getTempalteDetailList(id))
                .then(unwrapResult)
                .then((details) => {
                  setTemplateDetails({
                    ...templateDetails,
                    [id]: details,
                    ['-1']: commonList,
                  })
                })
            }
          }
        })
      })
      .catch(() => {
        // do nothing.
      })
  }, [templateKeyword])

  useEffect(() => {

    const defaultCategory = (tenantCountyCode?.indexOf("3307")== 0 && registrations?.insuranceCode !== 'ZIFEI') ? TreatmentCategory.GeZhang : TreatmentCategory.Normal;

    TcmCasesForm.setFieldsValue({
      treatmentCategory: defaultCategory,
    })
    return () => {
      dispatch(resetTcmCase())
    }
  }, [])

  useEffect(() => {
    if (!registration?.patientId) return
    // 历史病历
    getHistoryList()
  }, [seeOtherDoctor, registration?.patientId])

  const getHistoryList = (num?:any)=>{
    const [head, tail] = getDateRange(DateRangeType.RecentYear)
    const data = {
      current: 1,
      size: 50,
      medicalRecord: 2,
      treatmentTimeHead: num ? moment().subtract(num, 'year').format(DateTimeFormat): head,
      treatmentTimeTail: tail,
      patientId: registration?.patientId,
      treatmentDoctorId: seeOtherDoctor ? userId : undefined,
      state: 3,
    }
    dispatch(getTcmTreatmentOldList(data))
      .then(unwrapResult)
      .then((res: any) => {
        setHistoryList(res.records)
        const first = res?.records[0]?.id
        setCollapseActivekey(first)
        if (first) {
          dispatch(getRecipeList(first))
            // dispatch(getRecipeLists({ treatmentId: first, excludeType: 1 }))
            .then(unwrapResult)
            .then((res) => {
              setHistoryData({
                ...historyData,
                [first]: res,
              })
            })
        }
      })
  }

  const getBMI = async (v: boolean) => {
    try {
      const values = await TcmCasesForm.validateFields(['patientWeight', 'patientHeight'])
      let BMI = ''

      if (v && values.patientWeight && values.patientHeight) {
        BMI = (
          (values.patientWeight / (values.patientHeight * values.patientHeight)) *
          10000
        )
          .toFixed(1)
          .toString()
      }
      TcmCasesForm.setFieldsValue({
        BMI,
      })
    } catch (error) {
      const values = TcmCasesForm.getFieldsValue()
      let BMI = ''

      if (v && values.patientWeight && values.patientHeight) {
        BMI = (
          (values.patientWeight / (values.patientHeight * values.patientHeight)) *
          10000
        )
          .toFixed(1)
          .toString()
      }
      TcmCasesForm.setFieldsValue({
        BMI,
      })
    }
  }

  // const TcmEl = (v: any): ReactElement => (
  //   <div >
  //     {
  //       v.itemList.length ? (
  //         <>
  //           <Divider />
  //           <Row>{getRecipeCategoryName(v.category)}</Row>
  //           {

  //             (v.category == RecipeCategory.Tcm || v.category === RecipeCategory.TcmGranules) ? (
  //               <Row gutter={[4, 4]}>
  //                 {
  //                   v.itemList.map((el: any, i: number) => (
  //                     <Col span={8} key={i}>
  //                       {el.name} {el.countPerTip}{el.accountUnit}
  //                     </Col>
  //                   ))
  //                 }
  //               </Row>
  //             ) : (
  //               <Table
  //                 pagination={false}
  //                 size='small'
  //                 bordered
  //                 columns={TcmMedicineMaterialColumns(theme)}
  //                 dataSource={v.itemList}
  //               />
  //             )
  //           }
  //         </>
  //       ) : ''
  //     }
  //   </div>
  // )

  const copyRecipe = (vs: any) => {
    const params = vs as CopyTreatmentParams
    setIsModalVisible(false)
    if (params.copyRecipe) {
      setIsCopyReciptModalVisible(true)
      setIsCopyReciptParam(params)
      // Modal.confirm({
      //   title: '是否从处方复制价格？',
      //   cancelText: '使用目录价格',
      //   okText: '使用处方价格',
      //   onOk: () => {
      //     dispatch(
      //       copyTreatment({
      //         ...params,
      //         registrationId,
      //         copyWithAmount: true,
      //       })
      //     )
      //       .then(unwrapResult)
      //       .then(() => {
      //         notification.success({
      //           message: '病历和处方已复制',
      //         })
      //         dispatch(
      //           getTreatment({
      //             registrationId,
      //             treatmentId,
      //           })
      //         )
      //       })
      //   },
      //   onCancel: () => {
      //     dispatch(
      //       copyTreatment({
      //         ...params,
      //         registrationId,
      //         copyWithAmount: false,
      //       })
      //     )
      //       .then(unwrapResult)
      //       .then(() => {
      //         notification.success({
      //           message: '病历和处方已复制',
      //         })
      //         dispatch(
      //           getTreatment({
      //             registrationId,
      //             treatmentId,
      //           })
      //         )
      //       })
      //   },
      // })
    } else {
      dispatch(copyTreatment({ ...params, registrationId, allergen: TcmCasesForm.getFieldValue('allergen') })).then(() => {
        notification.success({
          message: '病历已复制',
        })
        getRefreshList(registrationId,treatmentId)
      })
    }
  }

  const onUpdateColl = (id: string) => {
    dispatch(getTempalteDetailList(id))
      .then(unwrapResult)
      .then(async (details) => {
        const commonList = await dispatch(commonListAsync('2')).then(
          unwrapResult
        )
        setTemplateDetails({
          ...templateDetails,
          [id]: details,
          ['-1']: commonList,
        })
      })
      .finally(() => {
        setLoading(false)
      })
  }

  const like = useCallback(
    _.debounce((d) => {
      setLoading(true)
      dispatch(
        commonSaveAsync({
          itemId: d.id,
          medicalRecord: 2,
        })
      )
        .then(unwrapResult)
        .then(() => {
          onUpdateColl(d.templateId)
        })
        .catch(() => {
          setLoading(false)
        })
    }, 500),
    []
  )

  const liked = useCallback(
    _.debounce((d) => {
      dispatch(commonRemoveAsync(d.commonId))
        .then(unwrapResult)
        .then(() => {
          onUpdateColl(d.templateId)
        })
        .catch(() => {
          setLoading(false)
        })
    }, 500),
    []
  )
  const addMessage = (message:any) => {
    setAiMsg((prevMsg) => [...prevMsg, message]);
  };

  useEffect(() => {
    if (aiMsg.length > 0 && aiMsg[aiMsg.length-1]?.role!="system") {
      let param = {
        registrationId:registrationId,
        timestamp:Date.now(),
        diag:selectedDiseases.map(diag => `${diag.name}(${diag.icds})`).join(', '),
        category:11,
        departmentName:departments.find(
          (d) => d.id === treatmentForm.getFieldValue("treatmentDepartmentId")
        )?.name
      }
      if("重写一份" != aiBtnText){
        param = {
          ...param,
          ...treatmentForm?.getFieldsValue(),
          ...TcmCasesForm?.getFieldsValue(),
        }
      }

      if(param.departmentName && param?.departmentName?.indexOf("盲人")>=0){
        setAiPlusText("正在生成盲人病历");
      }else if(param.departmentName && param?.departmentName?.indexOf("针灸")>=0){
        setAiPlusText("正在生成针灸病历");
      }else if(param.departmentName && param?.departmentName?.indexOf("推拿")>=0){
        setAiPlusText("正在生成推拿病历");
      }


      // 当 aiMsg 有新内容时再调用 API
      HydGPTRun(token,param, {
        onMessage: (d:any) => convertToFormText(d,param.departmentName || "")
      }).then((d:any) => {
        setAiBtnText("重写一份")
        addMessage({
          role: "system",
          content: d?.text
        });
      }).catch((e) => {
        setAiBtnText("AI写病历")
        if(e?.indexOf("MYD-")>=0){
          notification.error({ message: e.replace('MYD-','') })
        }else{
          notification.error({ message: '服务器繁忙，请稍后再试。' })
        }

      }).finally(()=>{
        setAiPlusText("");
        setAicheckDone(true);
        formatAiMsg();
      });
    }
  }, [aiMsg]); // 依赖 aiMsg 的变化


  const formatAiMsg = () =>{
    //对治疗意见做一次格式化
    const tc = TcmCasesForm.getFieldValue("treatmentConclusion");
    if(tc && tc.indexOf("2.")>=0 && tc.indexOf("3.")>=0 ){
      //如果是行号1开始，则从第二行开始格式化
      if(tc.indexOf("1.") == 0){
        TcmCasesForm.setFieldsValue(
          {
            treatmentConclusion: tc.replace(/([2-9]\d*\.\s*|\d{2,}\.\s*)/gm, '\n$1')
          }
        )
      }else{
        //如果行号为1不是第一行内容，则所有行全部格式化
        TcmCasesForm.setFieldsValue(
          {
            treatmentConclusion: tc.replace(/(\d+\.\s*)/gm, '\n$1')
          }
        )
      }

    }
    //体格检查格式化
    const tg = TcmCasesForm.getFieldValue("physicalExamination");
    if(tg && tg.indexOf("2.")>=0 && tg.indexOf("3.")>=0 ){
      //如果是行号1开始，则从第二行开始格式化
      if(tg.indexOf("1.") == 0){
        TcmCasesForm.setFieldsValue(
          {
            physicalExamination: tg.replace(/([2-9]\d*\.\s*|\d{2,}\.\s*)/gm, '\n$1')
          }
        )
      }else{
        //如果行号为1不是第一行内容，则所有行全部格式化
        TcmCasesForm.setFieldsValue(
          {
            physicalExamination: tg.replace(/(\d+\.\s*)/gm, '\n$1')
          }
        )
      }

    }
  }
  const convertToFormText = (d:any,departmentName:string) =>{
    // eslint-disable-next-line no-control-regex
    const realD = d?.text?.replace(new RegExp('\r\n', 'g'), '').replace(new RegExp('\n', 'g'), '')

    // 定义每个部分的起始和结束关键字
    const mainComplaintStart = '主诉：';
    const currentIllnessStart = '现病史：';
    const pastHistoryStart = '既往史：';
    const treatmentAdviceStart = '治疗方案：';
    const mxStart = '脉象：';
    const sxStart = '舌象：';
    const bodyCheckStart = '体格检查：';

    // 提取主诉
    const mainComplaintIndex = realD.indexOf(mainComplaintStart);
    const currentIllnessIndex = realD.indexOf(currentIllnessStart);
    if (mainComplaintIndex !== -1 ) {
      TcmCasesForm.setFieldsValue(
          {
            chiefComplaint: realD.substr(
                mainComplaintIndex + mainComplaintStart.length,
                (currentIllnessIndex - (mainComplaintIndex + mainComplaintStart.length))<0?realD.length:(currentIllnessIndex - (mainComplaintIndex + mainComplaintStart.length))
            ).trim()
          }
      )

    }

    // 提取现病史
    const pastHistoryIndex = realD.indexOf(pastHistoryStart);
    if (currentIllnessIndex !== -1 ) {
      TcmCasesForm.setFieldsValue(
          {
            historyOfPresentIllness: realD.substr(
                currentIllnessIndex + currentIllnessStart.length,
                (pastHistoryIndex - (currentIllnessIndex + currentIllnessStart.length))<0?realD.length:(pastHistoryIndex - (currentIllnessIndex + currentIllnessStart.length))
            ).trim()
          }
      )
    }
    //盲人病历不生成舌象脉象
    if(departmentName && departmentName.indexOf("盲人")>=0){
      // 提取既往史
      const bodyCheckStartIndex = realD.indexOf(bodyCheckStart);
      if (pastHistoryIndex !== -1 ) {
        TcmCasesForm.setFieldsValue(
          {
            pastMedicalHistory: realD.substr(
              pastHistoryIndex + pastHistoryStart.length,
              bodyCheckStartIndex - (pastHistoryIndex + pastHistoryStart.length)<0?realD.length:bodyCheckStartIndex - (pastHistoryIndex + pastHistoryStart.length)
            ).trim()
          }
        )
      }

      // 提取体格检查
      const treatmentAdviceIndex = realD.indexOf(treatmentAdviceStart);
      if (bodyCheckStartIndex !== -1 ) {
        TcmCasesForm.setFieldsValue(
          {
            physicalExamination: realD.substr(
              bodyCheckStartIndex + bodyCheckStart.length,
              treatmentAdviceIndex - (bodyCheckStartIndex + bodyCheckStart.length)<0?realD.length:treatmentAdviceIndex - (bodyCheckStartIndex + bodyCheckStart.length)
            ).trim()
          }
        )
      }

      // 提取治疗意见
      if (treatmentAdviceIndex !== -1) {
        TcmCasesForm.setFieldsValue(
          {
            treatmentConclusion: realD.substr(
              treatmentAdviceIndex + treatmentAdviceStart.length
            ).trim()
          }
        )
      }
    }else{
      // 提取既往史
      const sxIndex = realD.indexOf(sxStart);
      if (pastHistoryIndex !== -1 ) {
        TcmCasesForm.setFieldsValue(
          {
            pastMedicalHistory: realD.substr(
              pastHistoryIndex + pastHistoryStart.length,
              sxIndex - (pastHistoryIndex + pastHistoryStart.length)<0?realD.length:sxIndex - (pastHistoryIndex + pastHistoryStart.length)
            ).trim()
          }
        )
      }

      // 提取舌象
      const mxIndex = realD.indexOf(mxStart);
      if (sxIndex !== -1 ) {
        TcmCasesForm.setFieldsValue(
          {
            tonguePicture: realD.substr(
              sxIndex + sxStart.length,
              mxIndex - (sxIndex + sxStart.length)<0?realD.length:mxIndex - (sxIndex + sxStart.length)
            ).trim()
          }
        )
      }

      // 提取脉象
      const bodyCheckIndex = realD.indexOf(bodyCheckStart);
      if (mxIndex !== -1 ) {
        TcmCasesForm.setFieldsValue(
          {
            pulseCondition: realD.substr(
              mxIndex + mxStart.length,
              bodyCheckIndex - (mxIndex + mxStart.length)<0?realD.length:bodyCheckIndex - (mxIndex + mxStart.length)
            ).trim()
          }
        )
      }

      // 提取体格检查
      const treatmentAdviceIndex = realD.indexOf(treatmentAdviceStart);
      if (bodyCheckIndex !== -1 ) {
        TcmCasesForm.setFieldsValue(
          {
            physicalExamination: realD.substr(
              bodyCheckIndex + bodyCheckStart.length,
              treatmentAdviceIndex - (bodyCheckIndex + bodyCheckStart.length)<0?realD.length:treatmentAdviceIndex - (bodyCheckIndex + bodyCheckStart.length)
            ).trim()
          }
        )
      }

      // 提取治疗意见
      if (treatmentAdviceIndex !== -1) {
        TcmCasesForm.setFieldsValue(
          {
            treatmentConclusion: realD.substr(
              treatmentAdviceIndex + treatmentAdviceStart.length
            ).trim()
          }
        )
      }

    }



  }

  const listOverlay = [
    { name: 'zhang', id: 1 },
    { name: 'hahha', id: 2 },
  ]

  const Overlay = ( 
    <Menu style={{ height: '300px', overflowY: 'scroll' }}>
      {listOverlay?.map((p: any) => (
        <Menu.Item
          key={p.id}
          onClick={() => {
            return
          }}
        >
          <Space>
            <span>{p.name}</span>
          </Space>
        </Menu.Item>
      ))}
    </Menu>
  )
  
  const getRefreshList = (registrationId:any,treatmentId:any)=>{
    dispatch(
      getTreatment({
        registrationId,
        treatmentId,
        medicalRecord:2,
      })
    )
  }


  const getRecipeItemToConclusion = ()=>{
    setRecipeItemToConclusionLoading(true);
    let conclusionText = TcmCasesForm.getFieldValue("treatmentConclusion");
    let inspectionCheckText = TcmCasesForm.getFieldValue("inspectionCheck");

    if(conclusionText && conclusionText.length>0){
      conclusionText+="\r\n";
    }
    if(inspectionCheckText && inspectionCheckText.length>0){
      inspectionCheckText+="\r\n";
    }
    if(!treatment?.id){
      notification.error({
        message: '请先保存病历并开具处方',
      })
      setRecipeItemToConclusionLoading(false);
      return;
    }
    dispatch(getRecipeList(treatment.id))
      .then(unwrapResult)
      .then((v: any) => {
        const itemList:any = [];
        v?.map((v:any) =>{
          if(v?.itemList?.length>0){
            itemList.push(v?.itemList);
          }
        })
        if(!v || v.length<=0 || itemList.length<=0){
          notification.error({
            message: '您还未开具处方，无法将处方内容引入治疗意见。',
          })
          setRecipeItemToConclusionLoading(false);
          return;
        }else{
          let lastRecipeId = 0;
          itemList.flat().map((r:any) => {
            //已退费和挂号费和代煎费不做导入
            if(r.state == 5 || r.billingCategory == '30' || r.billingCategory == '97'){
              return;
            }
            if(lastRecipeId >0 && lastRecipeId != r.recipeId){
              if(conclusionText.lastIndexOf("，")==conclusionText.length-1){
                conclusionText = conclusionText.substring(0,conclusionText.length-1)
              }
              conclusionText += "\r\n";
            }
            if(r.billingCategory == '03'){
              conclusionText+= r.name + "  " + r.countPerTip +""+r.accountUnit + "，"
            }else if(r.drugType == '1'){//诊疗项目录入到辅助检查中
              if(r.billingCategory == '07' || r.billingCategory == '09' || r.billingCategory == '23' || r.billingCategory == '24' ){
                inspectionCheckText += r.name + "      " + r.treatmentParts + "\r\n"
              }
            }else{
              conclusionText+= r.name + "      " + r.drugCount +"/"+r.accountUnit + "      " +r?.normalUsemethod + "      " + r.normalFrequency+"      "+ "每次"+r.normalDose+r.doseUnit+"\r\n"
            }
            lastRecipeId = r.recipeId;

          })
        }
        if(conclusionText.lastIndexOf("，")==conclusionText.length-1){
          conclusionText = conclusionText.substring(0,conclusionText.length-1)
        }
        TcmCasesForm.setFieldsValue(
          {
            treatmentConclusion: conclusionText,
            inspectionCheck:inspectionCheckText
          }
        )

      }).finally(()=>{
      setRecipeItemToConclusionLoading(false);
    })
  }

  const checkInfectiousDiseaseBeforeSubmit = (): Promise<boolean> => {
    return new Promise((resolve) => {
      const isWesternDiagnosis = selectedDiseases?.length > 0;

      // 判断是否命中传染病编码（从接口数据匹配）
      const hitInfectiousIcd = isWesternDiagnosis && selectedDiseases.some((disease) => {
        if (!disease?.icds) return false
        // 在接口返回的传染病列表中查找匹配的 icds
        return infectiousDiseaseList.some((infectious) => infectious.icds === disease.icds)
      }) 

      // 判断流行病学史是否填写
      const isEpidemicFilled = (() => {
        if (lxbxsFlag) {
          // 初版：Radio 选了 true 或 false 都算填写
          const wmDiagFlag = TcmCasesForm.getFieldValue('wmDiagFlag')
          return wmDiagFlag !== undefined && wmDiagFlag !== null
        } else if (lxbxsNewFlag) {
          // 新版：文本不为空
          const lxbsContent = TcmCasesForm.getFieldValue('lxbsContent')
          return !!lxbsContent?.trim()
        }
        return false
      })()

      if (hitInfectiousIcd) {
        const flag = localStorage.getItem('FIRSTNOXY_INFECTIOUS')
        if (flag == '1') {
          resolve(true)
        } else {
          let content = ''
          if (!isEpidemicFilled) {
            content = '该疾病为传染病，请补充完整流行病学史并及时去报卡登记'
          } else {
            content = '该疾病为传染病，请及时去报卡登记'
          }
          Modal.confirm({
            centered: true,
            title: '传染病提醒',
            content: (
              <>
                <div>
                  <ExclamationCircleFilled
                    style={{ color: '#FFAE55', fontSize: 18 }}
                  />
                  &nbsp;{content}
                </div>
                <div style={{ position: 'relative', bottom: -60 }}>
                  <Checkbox
                    onChange={({ target }) => {
                      const { checked } = target
                      const flag = checked ? '1' : '0'
                      localStorage.setItem('FIRSTNOXY_INFECTIOUS', flag)
                    }}
                    style={{ margin: '10px 0' }}
                  >
                    下次不再提示
                  </Checkbox>
                </div>
              </>
            ),
            okText: '确认',
            cancelText: '取消',
            icon: null,
            onOk: () => resolve(true),
            onCancel: () => resolve(false),
          })
        }
        return
      }

      // 判断发热/发烧
      const hasFeverKeyword = (text: string | undefined) => {
        if (!text) return false
        // 是否出现发热关键词
        const feverRegex = /发热|发烧/
        if (!feverRegex.test(text)) return false
        // 否定表达（否定词 + 0-2个字 + 发热）
        const negativeRegex = /(无|未|未见|未诉|未及|没有|不|否认|排除|除外|尚无|尚未|暂无|暂未)[^，。；,.]{0,3}(发热|发烧)/
        if (negativeRegex.test(text)) return false
        return true
      }
      const chiefComplaint = TcmCasesForm.getFieldValue('chiefComplaint') || ''
      const presentIllness = TcmCasesForm.getFieldValue('historyOfPresentIllness') || ''
      const physicalExam = TcmCasesForm.getFieldValue('physicalExamination') || ''
      const temperatureStr = TcmCasesForm.getFieldValue('patientTemperature') || ''
      const temperatureVal = parseFloat(temperatureStr)

      const textFeverHit =
        hasFeverKeyword(chiefComplaint) ||
        hasFeverKeyword(presentIllness) ||
        hasFeverKeyword(physicalExam)
      const tempFeverHit = !isNaN(temperatureVal) && temperatureVal > 37.5

      if (textFeverHit || tempFeverHit) {
        if (!isEpidemicFilled) {
          const flag = localStorage.getItem('FIRSTNOXY_FEVER')
          if (flag == '1') {
            resolve(true)
          } else {
            Modal.confirm({
              centered: true,
              title: '传染病提醒',
              content: (
                <>
                  <div>
                    <ExclamationCircleFilled
                      style={{ color: '#FFAE55', fontSize: 18 }}
                    />
                    &nbsp;该患者可能得了传染病，请补充完整流行病学史
                  </div>
                  <div style={{ position: 'relative', bottom: -60 }}>
                    <Checkbox
                      onChange={({ target }) => {
                        const { checked } = target
                        const flag = checked ? '1' : '0'
                        localStorage.setItem('FIRSTNOXY_FEVER', flag)
                      }}
                      style={{ margin: '10px 0' }}
                    >
                      下次不再提示
                    </Checkbox>
                  </div>
                </>
              ),
              okText: '确认',
              cancelText: '取消',
              icon: null,
              onOk: () => resolve(true),
              onCancel: () => resolve(false),
            })
            return
          }
        }
      }

      resolve(true)
    })
  }

  const saveSubmit = async (saveFlag?: any) => {
    if(lxbxsFlag || lxbxsNewFlag) {
      const canContinue = await checkInfectiousDiseaseBeforeSubmit()
      if (!canContinue) return
    }


    const flag = localStorage.getItem('FIRSTNOXY')
    const treatmentDoctorIdNoNumber = !isNaN(
      Number(treatmentForm.getFieldValue('treatmentDoctorId'))
    )
    // 勾选过下次不再提示
    if (flag == '1') {
      await submit(false,false,saveFlag)
      // if(!treatmentDoctorIdNoNumber){
      //   return
      // }else {
      //   saveEdit()
      // }
    } else {
      if (registrations?.insuranceCode !== 'ZIFEI') {
        if (
          selectedDiseases?.length &&
          selectedDiseases?.[0]?.diagType != 1 &&
          selectedDiseases?.[0]?.diagType
        ) {
          Modal.confirm({
            centered: true,
            title: '',
            content: (
              <>
                <div>
                  <ExclamationCircleFilled
                    style={{ color: '#FFAE55', fontSize: 18 }}
                  />
                  &nbsp;主诊断非西医诊断，有医保扣款风险，是否确定保存？
                </div>
                <div style={{ position: 'relative', bottom: -60 }}>
                  <Checkbox
                    onChange={({ target }) => {
                      const { checked } = target
                      const flag = checked ? '1' : '0'
                      localStorage.setItem('FIRSTNOXY', flag)
                    }}
                    style={{ margin: '10px 0' }}
                  >
                    下次不再提示
                  </Checkbox>
                </div>
              </>
            ),
            okText: '确认',
            cancelText: '取消',
            icon: null,
            onOk: async () => {
              await submit(false,false,saveFlag)
              // if(!treatmentDoctorIdNoNumber){
              //   return
              // }else {
              //   saveEdit()
              // }
            },
            onCancel: () => {
              return
            },
          })
        } else {
          await submit(false,false,saveFlag)
          // if(!treatmentDoctorIdNoNumber){
          //   return
          // }else {
          //   saveEdit()
          // }
        }
      } else {
        await submit(false,false,saveFlag)
        // if(!treatmentDoctorIdNoNumber){
        //   return
        // }else {
        //   saveEdit()
        // }
      }
    }
  }

  const getPatientDetailData = () =>{
    const wmDiagFlag = TcmCasesForm.getFieldValue('wmDiagFlag')
    if(lxbxsFlag && wmDiagFlag){
      if (registration?.patientId || registrations?.patientId){
        // 获取患者信息
        dispatch(
          getPatientDetail(
            registration?.patientId || registrations?.patientId
          )
        )
          .then(unwrapResult)
          .then(async (pateint) => {
            setPatient(pateint)
            if (
              !pateint?.idCardNumber ||
              !pateint?.phone ||
              !pateint?.provinceCode ||
              !pateint?.address
            ) {
              await setIsReplenishPatientModalVisible(true)
            } 
          })
          .catch(() => {
            // do nothing.
          })
      }
      
    }
  }

  useEffect(() => {
    if(!aiSwitch){
      return;
    }
    if(!registration || registration == null ){
      return;
    }
    // 检查是否已经显示过引导
    const hasShownGuide = localStorage.getItem('aiGuideShown');
    //暂时关闭
    return;
    if (hasShownGuide != null && hasShownGuide == '1') {
      return; // 如果已经显示过，就不再次显示
    }
    const driverObj = driver({
      steps: [
        {
          element: '.first-feature',
          popover: {
            title: 'AI助您写病历',
            description: '只需填写简要的诊断信息，即可一键生成完善精确的电子病历。',
            side: 'top', // 使用 side 而不是 position
            nextBtnText:"下一个"

          }
        },
        {
          element: '.second-feature',
          popover: {
            title: 'AI辅诊助您分析病情',
            description: '根据历史病历、医保历史信息等因素进行AI分析，并给出理性的治疗意见。',
            side: 'top', // 使用 side 而不是 position
          }
        }
      ],
      overlayOpacity: 0.5,
      animate: true,
      doneBtnText: '我知道了 ✓',
      showButtons:["next","close"],
      // 监听引导销毁事件
      onDestroyed: () => {
        // 将引导状态记录到 localStorage
        localStorage.setItem('aiGuideShown', '1');
        console.log('引导已结束，状态已保存');
      },

      // 也可以监听关闭事件
      onCloseClick: () => {
        localStorage.setItem('aiGuideShown', '1');
        console.log('用户主动关闭引导');
      }
    });

    // 自动开始引导
    setTimeout(() => {
      driverObj.drive();
    }, 100);

    return () => {
      driverObj.destroy();
    };
  }, [registration]);



  // 🌟 外部按钮点击：切换悬浮组件显隐
  const toggleVoiceFloat = () => {
    if (showVoiceFloat) {
      // 隐藏前先停止录音，避免麦克风残留
      voiceRef.current?.stopRecord();
      setShowVoiceFloat(false);
    } else {
      setShowVoiceFloat(true);
    }
  };

  const handleRecResult = (text: string, isFinal: boolean) => {
    // 示例：最终结果返回后，可自动隐藏组件
    if (isFinal) {
      speakTextArray.push(text);
    }
  };

  const handleRecError = (error: string) => {
    setShowVoiceFloat(false); // 错误时自动隐藏
    setSpeakTextArray([])
  };
  // 识别结束回调
  const handleRecFinish = () => {
    setShowVoiceFloat(false); // 错误时自动隐藏
    const param = {
      registrationId: registrationId,
      timestamp: Date.now(),
      diag: selectedDiseases.map(diag => `${diag.name}(${diag.icds})`).join(', '),
      category: 41,
      departmentName: departments.find(
        (d) => d.id === treatmentForm.getFieldValue("treatmentDepartmentId")
      )?.name,
      ...treatmentForm?.getFieldsValue(),
      ...TcmCasesForm?.getFieldsValue(),
      speakText:speakTextArray
    }
    setVoiceAiLoading(true);
    dispatch(
      getVoiceAiTreatment(param)
    )
      .then(unwrapResult)
      .then((details:any) => {
        if (voiceAiLoadingRef.current) {
          TcmCasesForm.setFieldsValue(
            {
              chiefComplaint: details?.chiefComplaint?.trim() || "",
              historyOfPresentIllness: details?.historyOfPresentIllness?.trim() || "",
              pastMedicalHistory: details?.pastMedicalHistory?.trim() || "",
              physicalExamination: details?.physicalExamination?.trim() || "",
              treatmentConclusion: details?.treatmentConclusion?.trim() || "",
              tonguePicture:details?.tonguePicture?.trim() || "",
              pulseCondition:details?.pulseCondition?.trim() || ""
            }
          )
          if(details.disease && details.disease.indexOf("/")>0){
            //如果带着诊断发起的语音病例，则诊断不覆盖
            if(!selectedDiseases?.length){
              const diseases = _.chain(details.disease)
                .split(',')
                .map((s) => s.split('/'))
                .map(
                  ([n, c]) =>
                    ({ name: n, icds: c } as Disease)
                )
                .value()
              setSelectedDiseases(diseases)
              setIsDiseaseEmpty(diseases.length === 0)
            }

          }
        }

      })
      .catch((e) => {
        // 即使报错，也只在未取消时提示
        if (voiceAiLoadingRef.current && e?.message?.indexOf("MYD") < 0) {
          notification.error({ message: '服务器繁忙，请稍后再试3。' + e?.message });
        }else{
          notification.error({ message: e?.message});
        }

      }).finally(()=>{
      // 只有未取消时，才重置状态
      if (voiceAiLoadingRef.current) {
        formatAiMsg();
        setVoiceAiLoading(false);
      }
      setSpeakTextArray([]);
    })

  };
  return (
    <div
      style={{
        display: 'flex',
        height: state === 1 ? '100% ' : 'calc(100% - 5px)',
        position: 'relative',
        flexDirection: 'column',
      }}
    >
      {showVoiceFloat && (
        <XfyunRTASRSimpleLLM
          ref={voiceRef}
          onResult={handleRecResult}
          onError={handleRecError}
          onFinish={handleRecFinish}
          closeModal={() =>{
            setShowVoiceFloat(false)
          }}

        />
      )}
      {state === 1 ? (
        <></>
      ) : (
        <Row
          style={{
            position: 'fixed',
            top: '102px',
            right: '20px',
            fontSize: '1rem',
            padding: '0 20px',
          }}
          align='middle'
        >
          <a
            type='text'
            style={{
              marginLeft: '6px',
              marginRight:'20px',
              fontSize: '16px',
              color: '#333'
            }}
          >
            接诊时间：{registration?.treatmentTime ? moment(registration?.treatmentTime).format('YYYY/MM/DD') :'-'}
          </a>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              color: '#027AFF',
            }}
            onClick={() => {
              setiPreferencesSetShow(true)
            }}
          >
            <SettingOutlined
              style={{
                fontSize: '20px',
                color: '#027AFF',
              }}
            />
            <a
              type='text'
              style={{
                marginLeft: '6px',
                fontSize: '16px',
                color: '#027AFF',
              }}
            >
              偏好设置
            </a>
          </div>
        </Row>
      )}
      <Row
        className={styles.container}
        style={{
          height: '100%',
          overflow: 'hidden',
          flex: 1,
          marginBottom: state === 1 ? '0' : '10px',
        }}
        wrap={false}
      >
        {state === 1 ? (
          <></>
        ) : (
          <Col
            style={{
              width: 242,
              height: '100%',
              marginRight: 10,
              backgroundColor: theme.pn,
              borderRadius: theme.br,
              overflow: 'auto',
            }}
          >
            <Label label='诊断模板' style={{ marginLeft: 20 }} />
            <Divider />
            <Input
              value={templateKeyword}
              placeholder='请输入内容检索'
              onChange={(e) =>
                setTemplateKeyword((e.target.value || '').trim())
              }
              style={{
                width: 'calc(100% - 40px)',
                marginTop: 20,
                marginLeft: 20,
              }}
              allowClear
            />
            <Spin spinning={loading}>
              <Collapse
                className={styles.templates}
                bordered={false}
                // defaultActiveKey={[templates[0]?.id]}
                activeKey={recipeCollapse}
                // collapsible='header'
                expandIcon={(v) =>
                  v.isActive ? (
                    <CaretDownFilled style={{ lineHeight: '26px' }} />
                  ) : (
                    <CaretRightFilled style={{ lineHeight: '26px' }} />
                  )
                }
                style={{
                  marginTop: 30,
                  marginLeft: 20,
                  marginRight: 20,
                  backgroundColor: 'transparent',
                }}
                onChange={(ids) => {
                  setRecipeCollapse(ids)
                  _.forEach(ids, (id) => {
                    if (!templateDetails[id]) {
                      const template = templates.find((t) => t.id === id)
                      if (template) {
                        dispatch(getTempalteDetailList(id))
                          .then(unwrapResult)
                          .then((details) => {
                            setTemplateDetails({
                              ...templateDetails,
                              [id]: details,
                            })
                          })
                      }
                    }
                  })
                }}
              >
                {templates.map((t) => (
                  <Collapse.Panel
                    key={t.id}
                    header={
                      <div
                        style={{
                          width: '100%',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap',
                          color: templateKeyword
                            ? undefined
                            : selectedCategoryId === t.id
                            ? theme.c1
                            : undefined,
                          fontWeight: templateKeyword
                            ? undefined
                            : selectedCategoryId === t.id
                            ? 'bold'
                            : 'normal',
                        }}
                        onClick={() => {
                          setSelectedCategoryId(t.id)
                        }}
                      >
                        {t.categoryName}
                      </div>
                    }
                  >
                    {templateDetails[t.id] &&
                      templateDetails[t.id]
                      .filter(
                        (d) =>
                          (!templateKeyword) ||
                          (isWubi == 1 ? (d.itemName.indexOf(templateKeyword) >= 0 || d.wubiCode.indexOf(templateKeyword) >= 0) : d.itemName.indexOf(templateKeyword) >= 0) ||
                          (isWubi == 1 ? d.wubiCode.indexOf(
                            templateKeyword.toUpperCase()
                          ) >= 0 : d.mnemonicCode.indexOf(
                            templateKeyword.toUpperCase()
                          ) >= 0)
                      )
                      .map((d, i) => (
                          <Row
                            key={d.id}
                            justify='space-between'
                            style={{
                              marginTop: 10,
                            }}
                          >
                            <Col span={20}>
                              <div
                                key={d.id}
                                onClick={() => {
                                  TcmCasesForm.setFields([
                                    { name: 'tcmCase', errors: [] },
                                  ])
                                  TcmCasesForm.setFieldsValue({
                                    ...d,
                                    disease: '',
                                    allergen: TcmCasesForm.getFieldValue('allergen') || d?.allergen || '',
                                    treatmentCategory:d.treatmentCategory == 0 || d.treatmentCategory == -1
                                    ? TreatmentCategory.Normal
                                    : d.treatmentCategory || TreatmentCategory.Normal,
                                    personalHistoryEnable: !!d.personalHistory,
                                    familyHistoryEnable: !!d.familyHistory,
                                    vaccineHistoryEnable: !!d.vaccineHistory,
                                    menstrualHistoryEnable: !!d.menstrualHistory,
                                    maritalHistoryEnable: !!d.maritalHistory,
                                    patientWaistline: d?.patientWaistline > 0 ? d?.patientWaistline : undefined
                                  })
                                  if (d?.patientWeight && d?.patientHeight) {
                                    const BMI = (
                                      (d?.patientWeight /
                                        (d?.patientHeight * d?.patientHeight)) *
                                      10000
                                    ).toFixed(1)
                                    TcmCasesForm.setFieldsValue({
                                      BMI,
                                    })
                                  }
                                  const diseases = _.chain(d.disease)
                                    .split(',')
                                    .map((s) => s.split('/'))
                                    .map(
                                      ([n, c]) =>
                                        ({ name: n, icds: c } as Disease)
                                    )
                                    .value()
                                  setSelectedDiseases(diseases)
                                  setIsDiseaseEmpty(diseases.length === 0)
                                  setSelectedCategoryId(t.id)
                                }}
                                style={{
                                  color: theme.tc2,
                                  fontSize: '1.125rem',
                                  cursor: 'pointer',
                                }}
                              >
                                {i + 1}. {d.itemName}
                              </div>
                            </Col>
                            <Col
                              span={4}
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                              }}
                            >
                              {d?.commonId && d?.commonId > 0 ? (
                                <LikeedIcon
                                  style={{
                                    width: '16px',
                                    height: '16px',
                                  }}
                                  onClick={(e) => {
                                    setLoading(true)
                                    e.stopPropagation()
                                    liked(d)
                                  }}
                                />
                              ) : (
                                <LikeIcon
                                  style={{
                                    width: '16px',
                                    height: '16px',
                                  }}
                                  onClick={(e) => {
                                    setLoading(true)
                                    e.stopPropagation()
                                    like(d)
                                  }}
                                />
                              )}
                            </Col>
                          </Row>
                        ))}
                  </Collapse.Panel>
                ))}
              </Collapse>
            </Spin>
          </Col>
        )}

        <Col
          flex='1'
          style={{
            height: '100%',
            overflow: 'hidden',
            borderRadius: readMode ? `0 0 0 ${theme.br}px` : `${theme.br}px`,
            backgroundColor: theme.pn,
            // 2. 添加相对定位，作为遮罩的定位参考
            position: 'relative',
          }}
          className={styles.containerForm}
        >

          {/* 毛玻璃 Loading 遮罩层（带渐变动画） */}
          {voiceAiLoading && (
            <div
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                // 毛玻璃核心样式
                backdropFilter: 'blur(8px)',
                WebkitBackdropFilter: 'blur(8px)', // 兼容 Safari
                // 左上到右下的渐变背景 + 动画基础设置
                background: 'linear-gradient(to right bottom, rgb(57 147 225 / 40%), rgb(219 134 239 / 31%), rgb(108 194 235 / 48%)) 0% 0% / 200% 200%',
                backgroundSize: '200% 200%', // 放大渐变范围，为动画预留空间
                animation: 'gradientSlide 3s ease infinite', // 绑定渐变动画
                // 确保遮罩在内容上方
                zIndex: 10,
                // 让 loading 图标居中
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                // 继承父元素的圆角
                borderRadius: readMode ? `0 0 0 ${theme.br}px` : `${theme.br}px`,
              }}
            >
              {/* Antd Spin 组件 */}
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                {/* Antd Spin 组件 */}
                <Spin size="large" tip="请稍等" />
                {/* 取消按钮：添加间距，让位置更美观 */}
                <a
                  onClick={()=>{setVoiceAiLoading(false)}}
                  style={{ marginTop: '16px', cursor: 'pointer' }} // 关键：marginTop 增加间距，cursor 优化交互
                >
                  点击这里取消
                </a>
              </div>
            </div>
          )}

          <Form form={treatmentForm} colon={false} className={styles.titleSelect}>
            <Row
              justify='space-between'
              style={{
                paddingRight: 30,
                width: '100%',
                padding: '10px 10px 10px 20px',
              }}
            >
              {/* <ParientInfoRow
                registrations={registrations}
                owelabel={owelabel}
                oweMoneyNum={oweMoneyNum}
                oweMoneyShow={oweMoneyShow}
                insuranceBean={insuranceBean}
                patientInsurance={patientInsurance}
              /> */}

              <Row
                style={{
                  width: 900,
                  marginLeft: '16px',
                }}
                gutter={10}
              >
                <Col span={7}>
                  <Form.Item
                    label='科室'
                    name='treatmentDepartmentId'
                    {...columnLayout}
                  >
                    <Select
                      disabled={!isDoctorEditable}
                      onChange={(v) => {
                        treatmentForm.setFieldsValue({
                          treatmentDoctorId: undefined,
                        })
                        dispatch(getDoctorsInDepartment(v))
                      }}
                      style={
                        {
                          // width: 170,
                          // marginLeft: '8px',
                        }
                      }
                    >
                      {departments.map((d) => (
                        <Select.Option key={d.id} value={d.id}>
                          {d.name}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={7}>
                  <Form.Item
                    label='医生'
                    name='treatmentDoctorId'
                   {...columnLayout}
                    rules={[
                      {
                        required: true,
                        message: '接诊医生不能为空',
                      },
                    ]}
                  >
                    <Select
                      disabled={!isDoctorEditable}
                      style={
                        {
                          // width: 160,
                          // marginLeft: '8px',
                        }
                      }
                    >
                      {doctors.map((d) => (
                        <Select.Option key={d.id} value={d.id}>
                          {d.name}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                    label='护士'
                    name='treatmentNurseId'
                    {...columnLayout}
                  >
                    <Select
                      // disabled={!isDoctorEditable}
                      style={
                        {
                          // width: 160,
                          // marginLeft: '8px',
                        }
                      }
                    >
                      {nurses.map((d) => (
                        <Select.Option key={d.id} value={d.id}>
                          {d.name}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={3} style={{display:'flex',alignItems:'center',width:'100%',marginLeft:'14px'}}>
                  {/* <Form.Item name='receiveTag' valuePropName='checked' style={{ width: '100%', margin: '0 0 0 10px' }}> */}
                  <Checkbox
                    checked={reuseType}
                    onChange={(e) => {
                      // if (e.target.checked) {
                      //   notification.info({
                      //     message: '请在右侧就诊历史病历中点击复诊按钮。'
                      //   })
                      // } else {
                      setReuseTreatmentId('')
                      setReuseType(e.target.checked)
                      // }
                    }}
                  >
                    复诊
                  </Checkbox>
                  {/* <div
                    style={{ fontSize: '20px', cursor: 'pointer' }}
                    onClick={() => setiPreferencesSetShow(true)}
                  >
                    <EllipsisOutlined />
                  </div> */}
                  {/* </Form.Item> */}
                </Col>
              </Row>
            </Row>
          </Form>
          {/* <Label label="疾病诊断" style={{ marginLeft: 20 }} /> */}
          <Divider />
          <Col style={{ height: 'calc(100% - 104px)', overflowY: 'auto',overflowX:'hidden' }} className={styles.containerForm}>
            <Spin spinning={pageLoading} style={{ paddingTop: '400px' }}>
              <Form
              form={TcmCasesForm}
              colon={false}
              className={styles.info}
              autoComplete='off'
              labelCol={{
                flex: '6.5rem',
              }}
              style={{ marginRight: 10 }}
            >
              {registration?.remark ? (
                <span
                  style={{
                    marginLeft: '112px',
                    position: 'relative',
                    top: '-2px',
                    color: '#027aff',
                  }}
                >
                  备注：{registration?.remark.replace('#', ',')}
                </span>
              ) : (
                ''
              )}
              {functionsFieldConfig?.map((v) => {
                if (v?.key == 'chiefComplaint') {
                  return (
                    <>
                      <Form.Item
                        label='主诉'
                        name='chiefComplaint'
                        rules={[
                          {
                            required: v?.isRequired,
                            message: '请输入主诉',
                          },
                        ]}
                      >
                        <FastInput action='zhusu' medicalRecord={2} />
                      </Form.Item>
                    </>
                  )
                } else if (v?.key == 'historyOfPresentIllness') {
                  return (
                    <>
                      <Form.Item
                        label='现病史'
                        name='historyOfPresentIllness'
                        rules={[
                          {
                            required: v?.isRequired,
                            message: '请输入现病史',
                          },
                          {
                            max: 6000,
                            message: '最长6000位!',
                          },
                        ]}
                      >
                        <FastInput action='xianbing' />
                      </Form.Item>
                    </>
                  )
                } else if (v?.key == 'lxbsContent') {
                  return (
                    <>
                      {lxbxsFlag ? (
                        <Form.Item label='流行病学史' required>
                          <Row
                            style={{
                              borderColor: '#d9d9d9',
                              borderRadius: 2,
                              borderWidth: 1,
                              borderStyle: 'solid',
                              padding: '4px 10px',
                            }}
                            align='middle'
                          >
                            <Form.Item
                              noStyle
                              name='wmDiagFlag'
                              rules={[
                                {
                                  required: true,
                                  message: '请选择流行病学史',
                                },
                              ]}
                            >
                              <Radio.Group
                                onChange={((v) => {
                                  if (v?.target?.value) {
                                    getPatientDetailData()
                                  }
                                })}
                              >
                                <Radio value={true}>是</Radio>
                                <Radio value={false}>否</Radio>
                              </Radio.Group>
                            </Form.Item>
                            <div>
                              有14天内基孔肯雅热、登革热等蚊媒传染病流行风险地区旅居史、接触史。
                            </div>
                          </Row>
                        </Form.Item>
                      ) : lxbxsNewFlag ?
                        <Form.Item label='流行病学史'
                          name='lxbsContent'
                        >
                          <HistoricalEpidemiologyFastInput value={TcmCasesForm?.getFieldValue('lxbsContent')} />
                        </Form.Item>
                        : (
                          <></>
                        )}
                    </>
                  )
                } else if (v?.key == 'pastMedicalHistory') {
                  return (
                    <>
                      <Form.Item
                        label='既往史'
                        name='pastMedicalHistory'
                        rules={[
                          {
                            required: v?.isRequired,
                            message: '请输入既往史',
                          },
                          {
                            max: 500,
                            message: '最长500位!',
                          },
                        ]}
                      >
                        <FastInput action='jiwang' />
                      </Form.Item>
                    </>
                  )
                } else if (v?.key == 'allergen') {
                  return (
                    <>
                      <Form.Item
                        label='过敏史'
                        name='allergen'
                        rules={[
                          {
                            required: v?.isRequired,
                            message: '请输入过敏史',
                          },
                          {
                            max: 500,
                            message: '最长500位!',
                          },
                        ]}
                      >
                        <FastInput action='guoming' />
                      </Form.Item>
                    </>
                  )
                } else if (v?.key == 'disease') {
                  return (
                    <>
                      {searchMedical && searchMedical.length !== 0 && (
                        <Form.Item label=' '>
                          <Text style={{ color: '#027AFF' }}>
                            该患者存在备案的特慢病信息，
                            <span
                              style={{ fontWeight: 'bold', cursor: 'pointer', textDecoration: 'underline' }}
                              onClick={() => {
                                setIsTipsModalVisible(true)
                              }}
                            >
                              点击引用
                            </span>
                            {/* {searchMedical?.map((v: any) => {
                      const disease = {
                        icds: v.diseaseCode,
                        id: v.id,
                        name: v.diseaseName,
                      }
                      return (
                        <span
                          style={{
                            padding: '0 10px',
                            cursor: 'pointer',
                            textDecoration: 'underline',
                            fontWeight: 'bold',
                          }}
                          key={v.icds}
                          onClick={() => {
                            if (
                              !selectedDiseases.find(
                                (d) => d?.icds === disease?.icds
                              )
                            ) {
                              setSelectedDiseases(
                                selectedDiseases.concat(disease as Disease)
                              )
                              diseasesChose(v)
                              // setIsOpen(true)
                            }
                          }}
                        >
                          {`${disease.name}/${disease.icds}`}
                        </span>
                      )
                    })} */}
                          </Text>
                        </Form.Item>
                      )}
                      <Form.Item
                        label='中医诊断'
                        name='disease'
                        required
                        rules={[
                          {
                            max: 500,
                            message: '最长500位!',
                          },
                          () => ({
                            validator: () => {
                              if (isDiseaseEmpty) {
                                return Promise.reject('请输入主要疾病')
                              }
                              return Promise.resolve()
                            },
                          }),
                        ]}
                      >
                        <Row wrap={false} style={{ height: '35px' }} gutter={10}>
                          <Col span={12}>
                            <DiseaseInput
                              isWubi={isWubi}
                              autoFocus={selectedDiseases?.length ? true : false}
                              isMedical={2}
                              insuranceCode={registration?.insuranceCode}
                              disabled={!isDiseaseEditable}
                              placeholder='请输入主要疾病'
                              onChange={() => setIsDiseaseEmpty(false)}
                              onSelect={(disease) => {
                                if (
                                  !selectedDiseases.find((d) => d.icds === disease.icds)
                                ) {
                                  setSelectedDiseases(selectedDiseases.concat(disease))
                                  TcmCasesForm.resetFields(['disease'])
                                }
                              }}
                            />
                          </Col>
                          <Col span={6} style={{ marginLeft: '-10px' }}>
                            <Form.Item
                              name='treatmentCategory'
                              // name={['disease', 'treatmentCategory']}
                              {...layout}
                            >
                              <Select
                                autoFocus={isOpen}
                                open={isOpen}
                                onClick={() => {
                                  setIsOpen(!isOpen)
                                }}
                                onBlur={() => {
                                  setIsOpen(false)
                                }}
                              >
                                {registration?.insuranceCode === 'CHONGQING' &&
                                  TreatmentCategoriesCQ.map((c) => (
                                    <Select.Option key={c} value={c}>
                                      {getTreatmentCategoryName(c)}
                                    </Select.Option>
                                  ))}
                                {registration?.insuranceCode === 'ZHEJIANG' &&
                                  TreatmentCategories.map((c) => (
                                    <Select.Option key={c} value={c}>
                                      {getTreatmentCategoryName(c)}
                                    </Select.Option>
                                  ))}
                                {registration?.insuranceCode === 'JIANGSU' &&
                                  TreatmentCategoriesJS.map((c) => (
                                    <Select.Option key={c} value={c}>
                                      {getTreatmentCategoryName(c)}
                                    </Select.Option>
                                  ))}
                                {(registration?.insuranceCode === 'ZIFEI' ||
                                  treatment?.insuranceCode === 'ZIFEI') &&
                                  TreatmentCategoriesZF.map((c) => (
                                    <Select.Option key={c} value={c}>
                                      {getTreatmentCategoryName(c)}
                                    </Select.Option>
                                  ))}
                              </Select>
                            </Form.Item>
                          </Col>
                          {!aiSwitch ? (
                            <Col span={6} style={{ marginLeft: '-10px' }}>
                              <Form.Item
                                name='infectiousDisease'
                                valuePropName='checked'
                              >
                                <Checkbox style={{ marginLeft: 10 }}>
                                  是否传染病
                                </Checkbox>
                              </Form.Item>
                            </Col>
                          ) : (
                            <Col span={6}>
                              {!aicheckDone && (
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                  <img
                                    src={AILoading}
                                    style={{ marginLeft: '10px', width: '35px' }}
                                  ></img>
                                  <div className={styles.loadingText}>{aiPlusText}</div>
                                </div>
                              )}
                              {aicheckDone && (
                                <div style={{
                                  display: 'flex',
                                }}>
                                  <Button
                                    shape='round'
                                    type='primary'
                                    className={"first-feature"}
                                    style={{
                                      background:
                                        'linear-gradient(to top right, rgb(124 205 237), rgb(151 115 221), rgb(255 32 174))',
                                      alignItems: 'center',
                                      marginLeft: 10,
                                      display: 'flex',
                                      borderColor: '#ffffff',
                                      fontWeight: 'bold',
                                    }}
                                    onClick={() => {
                                      if (selectedDiseases && selectedDiseases[0]?.name) {
                                        //检查协议
                                        const agree = localStorage.getItem(
                                          'aiagreement_' + userId
                                        )
                                        if (agree && agree == '1') {
                                          setAicheckDone(false)
                                          setAiMsg([
                                            {
                                              role: 'system',
                                              content: '1',
                                            },
                                            {
                                              role: 'user',
                                              content: '2',
                                            },
                                          ])
                                        } else {
                                          Modal.confirm({
                                            width: 800,
                                            centered: true,
                                            title: '免责声明',
                                            content: <AiAgreement></AiAgreement>,
                                            okText: '同意并继续',
                                            cancelText: '不同意',
                                            icon: null,
                                            onOk: () => {
                                              localStorage.setItem(
                                                'aiagreement_' + userId,
                                                '1'
                                              )
                                              setAicheckDone(false)
                                              setAiMsg([
                                                {
                                                  role: 'system',
                                                  content: '1',
                                                },
                                                {
                                                  role: 'user',
                                                  content: '2',
                                                },
                                              ])
                                            },
                                          })
                                        }
                                      } else {
                                        notification.error({
                                          message: '请先填写诊断',
                                        })
                                      }
                                    }}
                                  >
                                    {aiBtnText}
                                  </Button>
                                  {aiVoice &&
                                      <Button
                                          icon={<VoiceAiIcon />}
                                          shape='round'
                                          className={"first-feature"}
                                          type='primary'
                                          style={{
                                            background:
                                              'linear-gradient(to top right, rgb(124 205 237), rgb(151 115 221), rgb(255 32 174))',
                                            alignItems: 'center',
                                            marginLeft: 10,
                                            display: 'flex',
                                            borderColor: '#ffffff',
                                          }}
                                          onClick={() => {
                                            toggleVoiceFloat();
                                          }}
                                      >
                                          语音输入
                                      </Button>
                                  }
                                </div>
                              )}
                            </Col>
                          )}
                        </Row>
                      </Form.Item>
                      <Row
                        style={{
                          display: selectedDiseases.length === 0 ? 'none' : undefined,
                        }}
                      >
                        <Col flex='7.125rem' />
                        <Col
                          flex='1'
                          style={{
                            borderRadius: 2,
                            border: `1px solid ${theme.wbd}`,
                            padding: '10px 0 0 10px',
                            marginBottom: 10,
                          }}
                        >
                          {selectedDiseases.map((d) => (
                            <div key={d.icds} className={styles.disease}>
                              {`${d.name}/${d.icds}`}{' '}
                              <CloseOutlined
                                style={{ cursor: 'pointer' }}
                                onClick={() => {
                                  setSelectedDiseases(
                                    selectedDiseases.filter((i) => i.icds !== d.icds)
                                  )
                                }}
                              />
                            </div>
                          ))}
                        </Col>
                      </Row>
                    </>
                  )
                } else if (v?.key == 'medicalHistory') {
                  return (
                    <>
                      <Form.Item
                        label='病史'
                        required={v?.isRequired}
                        name=''
                        rules={[
                          ({ getFieldValue }) => ({
                            required: v?.isRequired,
                            validator: (_, value) => {
                              if (!submitFlag) {
                                return Promise.resolve()
                              }
                              if (v?.isRequired) {
                                const personalHistoryEnable = getFieldValue('personalHistoryEnable')
                                const familyHistoryEnable = getFieldValue('familyHistoryEnable')
                                const vaccineHistoryEnable = getFieldValue('vaccineHistoryEnable')
                                const menstrualHistoryEnable = getFieldValue('menstrualHistoryEnable')
                                const maritalHistoryEnable = getFieldValue('maritalHistoryEnable')

                                if (!personalHistoryEnable && !familyHistoryEnable && !vaccineHistoryEnable && !menstrualHistoryEnable && !maritalHistoryEnable) {
                                  return Promise.reject(new Error('请勾选病史'))
                                }
                              } else {
                                return Promise.resolve()
                              }
                            },
                          }),
                        ]}
                      >
                        <Row
                          style={{
                            borderColor: '#d9d9d9',
                            borderRadius: 2,
                            borderWidth: 1,
                            borderStyle: 'solid',
                            padding: '4px 10px',
                          }}
                          align='middle'
                        >
                          <Form.Item
                            noStyle
                            name='personalHistoryEnable'
                            valuePropName='checked'
                          >
                            <Checkbox>个人史</Checkbox>
                          </Form.Item>
                          <Form.Item
                            noStyle
                            name='familyHistoryEnable'
                            valuePropName='checked'
                          >
                            <Checkbox>家族史</Checkbox>
                          </Form.Item>
                          <Form.Item
                            noStyle
                            name='vaccineHistoryEnable'
                            valuePropName='checked'
                          >
                            <Checkbox>疫苗接种史</Checkbox>
                          </Form.Item>
                          <Form.Item
                            noStyle
                            name='menstrualHistoryEnable'
                            valuePropName='checked'
                          >
                            <Checkbox>月经史</Checkbox>
                          </Form.Item>
                          <Form.Item
                            noStyle
                            name='maritalHistoryEnable'
                            valuePropName='checked'
                          >
                            <Checkbox>婚育史</Checkbox>
                          </Form.Item>
                        </Row>
                      </Form.Item>
                      <Form.Item dependencies={['personalHistoryEnable']} noStyle>
                        {({ getFieldValue }) =>
                          getFieldValue('personalHistoryEnable') && (
                            <Form.Item
                              label='个人史'
                              name='personalHistory'
                              rules={[
                                {
                                  required: v?.isRequired,
                                  message: '个人史不能为空',
                                },
                                {
                                  max: 200,
                                  message: '最长200位!',
                                },
                              ]}
                            >
                              <FastInput action='geren' />
                            </Form.Item>
                          )
                        }
                      </Form.Item>
                      <Form.Item dependencies={['familyHistoryEnable']} noStyle>
                        {({ getFieldValue }) =>
                          getFieldValue('familyHistoryEnable') && (
                            <Form.Item
                              label='家族史'
                              name='familyHistory'
                              rules={[
                                {
                                  required: v?.isRequired,
                                  message: '家族史不能为空',
                                },
                                {
                                  max: 200,
                                  message: '最长200位!',
                                },
                              ]}
                            >
                              <FastInput action='jiazu' />
                            </Form.Item>
                          )
                        }
                      </Form.Item>
                      <Form.Item dependencies={['vaccineHistoryEnable']} noStyle>
                        {({ getFieldValue }) =>
                          getFieldValue('vaccineHistoryEnable') && (
                            <Form.Item
                              label='疫苗接种史'
                              name='vaccineHistory'
                              rules={[
                                {
                                  required: v?.isRequired,
                                  message: '疫苗接种史不能为空',
                                },
                                {
                                  max: 200,
                                  message: '最长200位!',
                                },
                              ]}
                            >
                              <FastInput action='ymjzs' />
                            </Form.Item>
                          )
                        }
                      </Form.Item>
                      <Form.Item dependencies={['menstrualHistoryEnable']} noStyle>
                        {({ getFieldValue }) =>
                          getFieldValue('menstrualHistoryEnable') && (
                            <Form.Item
                              label='月经史'
                              name='menstrualHistory'
                              rules={[
                                {
                                  required: v?.isRequired,
                                  message: '月经史不能为空',
                                },
                                {
                                  max: 200,
                                  message: '最长200位!',
                                },
                              ]}
                            >
                              <FastInput action='yuejin' />
                            </Form.Item>
                          )
                        }
                      </Form.Item>
                      <Form.Item dependencies={['maritalHistoryEnable']} noStyle>
                        {({ getFieldValue }) =>
                          getFieldValue('maritalHistoryEnable') && (
                            <Form.Item
                              label='婚育史'
                              name='maritalHistory'
                              rules={[
                                {
                                  required: v?.isRequired,
                                  message: '婚育史不能为空',
                                },
                                {
                                  max: 200,
                                  message: '最长200位!',
                                },
                              ]}
                            >
                              <FastInput action='hunyu' />
                            </Form.Item>
                          )
                        }
                      </Form.Item>
                    </>
                  )
                } else if (v?.key == 'tonguePicture') {
                  return (
                    <>
                      <Form.Item
                        label='舌象'
                        name='tonguePicture'
                        rules={[
                          {
                            required: v?.isRequired,
                            message: '舌象不能为空',
                          },

                        ]}>
                        <FastInput action='shexiang' />
                      </Form.Item>
                    </>
                  )
                } else if (v?.key == 'pulseCondition') {
                  return (
                    <>
                      <Form.Item
                        label='脉象'
                        name='pulseCondition'
                        rules={[
                          {
                            required: v?.isRequired,
                            message: '脉象不能为空',
                          },
                        ]}
                      >
                        <FastInput action='maixiang' />
                      </Form.Item>
                    </>
                  )
                } else if (v?.key == 'tgjc') {
                  return (
                    <>
                      <Form.Item
                        label='体格检查'
                        required={v?.isRequired}
                        name=''
                        rules={[
                          ({ getFieldValue }) => ({
                            required: v?.isRequired,
                            validator: (_, value) => {
                              if (!submitFlag) {
                                return Promise.resolve()
                              }
                              if (v?.isRequired) {
                                const temperature = getFieldValue('patientTemperature')
                                const patientSystolicPressure = getFieldValue('patientSystolicPressure')
                                const patientDiastolicPressure = getFieldValue('patientDiastolicPressure')
                                const patientPulse = getFieldValue('patientPulse')
                                const patientHeight = getFieldValue('patientHeight')
                                const patientWeight = getFieldValue('patientWeight')

                                if (!temperature || !patientSystolicPressure || !patientDiastolicPressure || !patientPulse || !patientHeight || !patientWeight) {
                                  return Promise.reject(new Error('体格检查不能为空'))
                                }
                                return Promise.resolve()
                              } else {
                                return Promise.resolve()
                              }
                            },
                          }),
                        ]}
                      >
                        <Row
                          style={{ height: 35, position: 'relative' }}
                          className={styles.checkGroup}
                        >
                          <Col style={{ width: '13%' }}>
                            <Form.Item
                              noStyle
                              name='patientTemperature'
                              rules={[
                                {
                                  message: '请输入最多带一位小数的数值',
                                  pattern: new RegExp(/^[0-9]+((\.)[0-9]?)?$/),
                                },
                              ]}
                            >
                              <Input
                                maxLength={4}
                                addonAfter='℃'
                                placeholder='体温'
                                onChange={(v) => {
                                  const value = v?.target?.value
                                  setDeleteFlag(false)
                                  if (!deleteFlag) {
                                    if (value.indexOf('.') !== -1) {
                                      TcmCasesForm.setFieldsValue({
                                        patientTemperature: value,
                                      })
                                    } else {
                                      if (value?.length == 2) {
                                        TcmCasesForm.setFieldsValue({
                                          patientTemperature: value + '.',
                                        })
                                      } else if (value?.length == 3) {
                                        TcmCasesForm.setFieldsValue({
                                          patientTemperature:
                                            value.slice(0, 2) + '.' + value.slice(2),
                                        })
                                      } else {
                                        TcmCasesForm.setFieldsValue({
                                          patientTemperature: value,
                                        })
                                      }
                                    }
                                  }
                                  if (v?.target?.value?.length == 4) {
                                    if (/(\.\.)/.test(value)) {
                                      TcmCasesForm.setFieldsValue({
                                        patientTemperature: value.slice(
                                          0,
                                          value?.length - 1
                                        ),
                                      })
                                    } else {
                                      patientSystolicPressureRef?.current?.focus()
                                    }
                                  }
                                }}
                                onPressEnter={() => {
                                  patientSystolicPressureRef?.current?.focus()
                                  const value = TcmCasesForm.getFieldValue(
                                    'patientTemperature'
                                  )
                                  if (value?.length == 3 && value.indexOf('.') !== -1) {
                                    TcmCasesForm.setFieldsValue({
                                      patientTemperature: value.slice(0, 2),
                                    })
                                  }
                                }}
                                onBlur={() => {
                                  const value = TcmCasesForm.getFieldValue(
                                    'patientTemperature'
                                  )
                                  if (value?.length == 3 && value.indexOf('.') !== -1) {
                                    TcmCasesForm.setFieldsValue({
                                      patientTemperature: value.slice(0, 2),
                                    })
                                  }
                                }}
                                onKeyDown={(e) => {
                                  // 允许使用 Backspace 和 Delete 键进行删除
                                  if (e.key === 'Backspace' || e.key === 'Delete') {
                                    setDeleteFlag(true)
                                  }
                                }}
                              />
                            </Form.Item>
                          </Col>
                          <Row style={{ width: '33%' }}>
                            <Col style={{ width: '36%' }}>
                              <Form.Item
                                name='patientSystolicPressure'
                                rules={[
                                  {
                                    message: '请输入整数值',
                                    pattern: new RegExp(/^[0-9]+$/),
                                  },
                                ]}
                              >
                                <Input
                                  className={Number(patientSystolicPressureValue) > 140 || Number(TcmCasesForm?.getFieldValue('patientSystolicPressure')) > 140 ? styles.textColore47a1f : styles.textColor}
                                  maxLength={3}
                                  placeholder='收缩压'
                                  ref={patientSystolicPressureRef}
                                  onChange={(v) => {
                                    setPatientSystolicPressureValue(v?.target?.value)
                                    if (v?.target?.value?.length == 3) {
                                      patientDiastolicPressureRef?.current?.focus()
                                    }
                                  }}
                                  onPressEnter={() => {
                                    patientDiastolicPressureRef?.current?.focus()
                                  }}
                                />
                              </Form.Item>
                            </Col>
                            <Col
                              style={{
                                paddingLeft: 9,
                                paddingTop: 5,
                              }}
                            >
                              /
                            </Col>
                            <Col style={{ flex: 1 }} className={Number(patientDiastolicPressureValue) > 90 || Number(TcmCasesForm?.getFieldValue('patientDiastolicPressure')) > 90 ? styles.textColore47a1fContent : styles.textColor}>
                              <Form.Item
                                name='patientDiastolicPressure'
                                rules={[
                                  {
                                    message: '请输入整数值',
                                    pattern: new RegExp(/^[0-9]+$/),
                                  },
                                ]}
                              >
                                <Input
                                  maxLength={3}
                                  addonAfter='mmHg'
                                  placeholder='舒张压'
                                  ref={patientDiastolicPressureRef}
                                  onChange={(v) => {
                                    setPatientDiastolicPressureValue(v?.target?.value)
                                    if (v?.target?.value?.length == 3) {
                                      patientPulseRef?.current?.focus()
                                    }
                                  }}
                                  onPressEnter={() => {
                                    patientPulseRef?.current?.focus()
                                  }}
                                />
                              </Form.Item>
                            </Col>
                          </Row>
                          <Col style={{ width: '15%' }}>
                            <Form.Item
                              name='patientPulse'
                              rules={[
                                {
                                  message: '请输入整数值',
                                  pattern: new RegExp(/^[0-9]+$/),
                                },
                              ]}
                            >
                              <Input
                                maxLength={5}
                                addonAfter='次/分'
                                placeholder='脉搏'
                                ref={patientPulseRef}
                                onChange={(v) => {
                                  if (v?.target?.value?.length == 3) {
                                    patientHeightRef?.current?.focus()
                                  }
                                }}
                                onPressEnter={() => {
                                  patientHeightRef?.current?.focus()
                                }}
                              />
                            </Form.Item>
                          </Col>
                          <Col style={{ width: '13%' }}>
                            <Form.Item
                              name='patientHeight'
                              rules={[
                                {
                                  message: '请输入最多带两位小数的数值',
                                  pattern: new RegExp(/^[0-9]+((\.)[0-9]{0,2})?$/),
                                },
                              ]}
                            >
                              <Input
                                maxLength={5}
                                addonAfter='cm'
                                placeholder='身高'
                                onChange={async (e) => {
                                  const v = e.target.value
                                  getBMI(!!v)
                                  if (v?.length == 3) {
                                    patientWeightRef?.current?.focus()
                                  }
                                }}
                                ref={patientHeightRef}
                                onPressEnter={() => {
                                  patientWeightRef?.current?.focus()
                                }}
                              />
                            </Form.Item>
                          </Col>
                          <Col style={{ width: '13%' }}>
                            <Form.Item
                              name='patientWeight'
                              rules={[
                                {
                                  message: '请输入最多带两位小数的数值',
                                  pattern: new RegExp(/^[0-9]+((\.)[0-9]{0,2})?$/),
                                },
                              ]}
                            >
                              <Input
                                maxLength={4}
                                addonAfter='kg'
                                placeholder='体重'
                                onChange={async (e) => {
                                  const v = e.target.value
                                  getBMI(!!v)
                                }}
                                ref={patientWeightRef}
                              />
                            </Form.Item>
                          </Col>
                          <Col style={{ width: '13%' }}>
                            <Form.Item name='BMI'>
                              <Input addonBefore='BMI' disabled />
                            </Form.Item>
                          </Col>
                        </Row>
                      </Form.Item>

                      {hisVersion == 1 ? (
                        <Form.Item label=' ' name='physicalExamination' rules={[
                          {
                            max: 500,
                            message: '最长500位!',
                          },
                        ]}>
                          <TextArea placeholder='其他体格检查' autoSize />
                        </Form.Item>
                      ) : (
                        <Row
                          style={{ display: 'flex', width: '100%' }}
                          className={styles.ywStyle}>
                          <Col style={{ flex: 1 }}>
                            <Form.Item label=' ' name='physicalExamination' rules={[
                              {
                                max: 500,
                                message: '最长500位!',
                              },
                            ]}>
                              <FastInput action='tigejiancha' placeholder='其他体格检查' />
                            </Form.Item>
                          </Col>
                          <Col style={{ width: '120px' }}>
                            <Form.Item
                              name='patientWaistline'
                              rules={[
                                {
                                  message: '请输入最多带两位小数的数值',
                                  pattern: new RegExp(/^[0-9]+((\.)[0-9]{0,2})?$/),
                                },
                              ]}
                            >
                              <Input
                                addonBefore='腰围'
                                maxLength={3}
                                addonAfter='cm'
                                placeholder='腰围'
                              />
                            </Form.Item>
                          </Col>
                        </Row>
                      )}
                    </>
                  )
                } else if (v?.key == 'inspectionCheck') {
                  return (
                    <>
                      <Form.Item
                        label='辅助检查'
                        name='inspectionCheck'
                        rules={[
                          {
                            required: v?.isRequired,
                            message: '辅助检查不能为空',
                          },
                          {
                            max: 500,
                            message: '最长500位!',
                          },
                        ]}
                      >
                        <TextArea placeholder='请输入内容' autoSize />
                      </Form.Item>
                    </>
                  )
                } else if (v?.key == 'treatmentConclusion') {
                  return (
                    <>
                      <Row style={{ display: 'flex' }}>
                        <Col style={{ flex: 1 }}>
                          <Form.Item label='治疗意见' name='treatmentConclusion' rules={[
                            {
                              required: v?.isRequired,
                              message: '治疗意见不能为空',
                            },
                            {
                              max: 500,
                              message: '最长500位!',
                            },
                          ]}>
                            <TextArea placeholder='请输入内容' autoSize />
                          </Form.Item>
                        </Col>
                        <Col style={{ width: '80px' }}>
                          <Button
                            type={"link"}
                            loading={recipeItemToConclusionLoading}
                            style={{ marginLeft: 10, display: "flex", alignItems: "center", height: "32px" }}
                            onClick={() => {
                              getRecipeItemToConclusion()
                            }}
                          >
                            录入处方
                          </Button>
                        </Col>
                      </Row>
                    </>
                  )
                } else if (v?.key == 'relatedImages') {
                  return (
                    <>
                      <Form.Item
                        label='相关影像'
                        name=''
                        required={v?.isRequired}
                        rules={[
                          {
                            required: v?.isRequired,
                            validator: (_, value) => {
                              if (!submitFlag) {
                                return Promise.resolve()
                              }
                              if (v?.isRequired && fileList.length === 0) {
                                return Promise.reject(new Error('相关影像不能为空'))
                              }
                              return Promise.resolve()
                            }
                          },
                        ]}>
                        <FileUpload
                          count={fileList.length || 0}
                          files={fileList}
                          onUpload={(v, i) => {
                            setFileList([
                              ...fileList,
                              {
                                uid: v.uid,
                                size: v.size,
                                name: v.name,
                                type: v.type,
                                originFileObj: {} as RcFile,
                                url: i,
                              },
                            ])
                          }}
                        >
                          {/* <Button icon={<PlusOutlined />}>上传附件</Button> */}
                        </FileUpload>
                        <Button
                          icon={<PlusOutlined />}
                          onClick={() => {
                            setIsUploadVisible(true)
                          }}
                        >
                          上传附件
                        </Button>
                        {fileList.map((item) => (
                          <Row
                            gutter={24}
                            key={item.uid}
                            style={{
                              padding: '10px',
                              width: '300px',
                            }}
                          >
                            <Col flex={1}>
                              <span
                                style={{
                                  display: 'inline-block',
                                  maxWidth: '60px',
                                  whiteSpace: 'nowrap',
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                  verticalAlign: 'middle',
                                }}
                              >
                                {item.name.split('.')[0]}
                              </span>
                              <span
                                style={{
                                  verticalAlign: 'middle',
                                }}
                              >
                                .{item.name.split('.')[1]}
                              </span>
                            </Col>
                            <Col span={6}>
                              <a
                                onClick={() => {
                                  dispatch(getUrl({ fileName: item.url }))
                                    .then(unwrapResult)
                                    .then((v: any) => {
                                      const proxy =
                                        window.location.origin.indexOf(
                                          'his.develop.hydhis.com'
                                        ) >= 0
                                          ? '/proxyToOssDevPrivate'
                                          : window.location.origin.indexOf(
                                            'his.test.hydhis.com'
                                          ) >= 0
                                            ? '/proxyToOssTestPrivate'
                                            : window.location.origin.indexOf(
                                              'hydhis.cn'
                                            ) >= 0
                                              ? '/proxyToOssProdPrivate'
                                              : '/proxyToOssProdPrivate'
                                      const url =
                                        (window.location.origin?.includes('localhost')
                                          ? 'http://his.develop.hydhis.com'
                                          : window.location.origin) +
                                        proxy +
                                        v
                                      setLookPic(url)
                                      setIsLookPicModalVisible(true)
                                      // window.open(v.replace('http:', 'https:'), '_blank')
                                    })
                                }}
                              >
                                查看
                              </a>
                            </Col>
                            <Col span={6}>
                              <CloseOutlined
                                onClick={() => {
                                  //  e.stopPropagation();
                                  setFileList(() =>
                                    fileList.filter((ite) => ite.uid !== item.uid)
                                  )
                                }}
                              />
                            </Col>
                          </Row>
                        ))}
                      </Form.Item>
                    </>
                  )
                }
              })}
              </Form>
            </Spin>
          </Col>
          <Row
            justify='space-between'
            style={{
              marginBottom: '180px',
              marginTop: hisVersion == 1 ? '16px' : '10px',
              marginRight: '10px',
            }}
          >
            <Space
              style={{
                marginLeft: 30,
              }}
            >
              <Button
                type='primary'
                disabled={!templates.length}
                onClick={async () => {
                  const values = await TcmCasesForm.validateFields()
                  const data = {
                    ...values,
                    medicalRecord: 2,
                    disease: selectedDiseases
                      .map((d) => `${d.name}/${d.icds}`)
                      .join(','),
                    chiefComplaint: values.chiefComplaint,
                    historyOfPresentIllness: values.historyOfPresentIllness,
                    inspectionCheck: values.inspectionCheck,
                    pulseCondition: values.pulseCondition,
                    tonguePicture: values.tonguePicture,
                    treatmentConclusion: values.treatmentConclusion,
                  }
                  setTargetTemplate(data)
                  setSaveTemplateModalVasible(true)
                }}
              >
                存为模板
              </Button>
            </Space>
            <Space>
              <Popover content={<div>点击会清空已填写的病历信息</div>} title="说明">
                <Button
                  type='primary'
                  ghost
                  onClick={() => {
                    TcmCasesForm.resetFields()
                    setSubmitFlag(false)
                    setSelectedDiseases([])
                    setFileList([])
                  }}
                >
                  清空
                </Button>
              </Popover>
              {readMode ? undefined : ( // </Button> //   另存为模版 // > //   }} //     } //       // do nothing. //     } catch { //       }); //         itemName: "", //           .join(","), //           .map((d) => `${d.name}/${d.icds}`) //         disease: selectedDiseases //         ...values, //       setTargetTemplate({ //       const values = await TcmCasesForm.validateFields(); //     try { //   onClick={async () => { //   type="primary" // <Button
                <Button
                  type='primary'
                  onClick={() => {
                    setTempType(false)
                    setIsModalVisible(true)
                  }}
                >
                  查看/选择 历史病历
                </Button>
              )}
              <Button
                loading={printLoading}
                type='primary'
                // disabled={!treatment?.id}
                onClick={async () => {
                  const needCheck = infectiousCheck?.[105] === '1101' || infectiousCheck?.[105] === '1102';
                  if (needCheck) {
                    // 需要检查时，执行传染病检查
                    const canContinue = await checkInfectiousDiseaseBeforeSubmit();
                    if (!canContinue) return;
                  }
                  setPrintLoading(true)
                  try {
                    await submit(true,true)
                    setIsPrintModalVisible(true)
                    setPrintLoading(false)
                  } catch {
                    setPrintLoading(false)
                    // do nothing.
                  }
                }}
              >
                打印
              </Button>
            </Space>
          </Row>
        </Col>
        <Col
          style={{
            width: 330,
            height: '100%',
            overflow: 'auto',
            marginLeft: 10,
            backgroundColor: theme.pn,
            position: 'relative',
            borderRadius: readMode ? `0 0 ${theme.br}px 0` : `${theme.br}px`,
          }}
        >
          <Tabs
            centered
            style={{ width: '100%', height: '100%' }}
            tabBarStyle={{
              marginBottom: 5,
            }}
            className={styles.tabs}
          >
            <TabPane
              tab={
                <span style={{ fontSize: '17px', fontWeight: 550 }}>
                  就诊历史
                </span>
              }
              key='0'
              style={{ height: '100%' }}
            >
              <HistoryPanel
                seeOtherDoctor={seeOtherDoctor}
                historyList={historyList?.map((v: any) => {
                  return {
                    ...v,
                    tgjc:
                      (v?.patientTemperature
                        ? '体温：'+v?.patientTemperature + '℃，'
                        : '') +
                      (v?.patientSystolicPressure
                        ? '血压：'+v?.patientSystolicPressure + '/'
                        : '') +
                      (v?.patientDiastolicPressure
                        ? v?.patientDiastolicPressure + 'mmHg，'
                        : '') +
                      (v?.patientPulse ? '脉搏：'+v?.patientPulse + '次/分，' : '') +
                      (v?.patientHeight ? '身高：'+v?.patientHeight + 'cm，' : '') +
                      (v?.patientWeight ? '体重：'+v?.patientWeight + 'kg，' : '') +
                      (v?.patientWeight && v?.patientHeight
                        ? 'BMI:' +
                          (
                            (v?.patientWeight /
                              (v?.patientHeight * v?.patientHeight)) *
                            10000
                          ).toFixed(1) +
                          '，'
                        : '') +
                      (v?.patientWaistline ? '腰围：'+v?.patientWaistline + 'cm，' : '') +

                      (v.physicalExamination ? v?.physicalExamination : ''),
                  }
                })}
                historyData={historyData}
                reuseTreatmentId={reuseTreatmentId}
                onChange={(v: string) => {
                  if (v && !historyData[v]) {
                    dispatch(getRecipeList(v))
                      // dispatch(getRecipeLists({ treatmentId: v, excludeType: 1 }))
                      .then(unwrapResult)
                      .then((res) => {
                        setHistoryData({
                          ...historyData,
                          [v]: res,
                        })
                      })
                  }
                }}
                onCopy={(type: boolean, srcTreatmentId: string) => {
                  copyRecipe({
                    copyRecipe: type,
                    srcTreatmentId,
                  })
                }}
                lookMoreHistoryList={((v)=>{
                  getHistoryList(v)
                })}
                CollapseActivekey={CollapseActivekey}
                changeAction={(action, v: any) => {
                  switch (action) {
                    case 'active':
                      setCollapseActivekey(v)
                      break
                    case 'check':
                      setSeeOtherDoctor(v)
                      break
                    case 'again':
                      if (v) {
                        setReuseType(true)
                        setReuseTreatmentId(v)
                      } else {
                        setReuseType(false)
                        setReuseTreatmentId('')
                      }
                      break
                    default:
                      break
                  }
                }}
              />
            </TabPane>
            <TabPane
              tab={
                <span style={{ fontSize: '17px', fontWeight: 550 }} className={"second-feature"} >
                  AI 辅诊
                </span>
              }
              key='1'
              style={{ height: '100%', overflow: 'auto' }}
            >
              {/*<Button onClick={()=>{*/}
              {/*  setAiLargeVisible(true);*/}
              {/*}}>*/}
              {/*  最大化*/}
              {/*</Button>*/}
              {!aiSwitch ? (
                <div style={{ textAlign: 'center', marginTop: 100 }}>
                  <p>您尚未开通此功能</p>
                  <br />
                  <p>如有需要请与服务人员联系。</p>
                </div>
              ) : (
                <AiTreatment
                  setRestoreFlag={setRestoreFlag}
                  setLargeVible={setAiLargeVisible}
                  largeVisible={aiLargeVisible}
                  baseData={baseData}
                  registrationId={registration?.id}
                  treatmentBody={{
                    registration: registrations,
                    diagnosisForm: TcmCasesForm,
                    treatmentForm: treatmentForm,
                    diag: selectedDiseases
                      .map((diag) => `${diag.name}(${diag.icds})`)
                      .join(', '),
                  }}
                ></AiTreatment>
              )}
            </TabPane>
          </Tabs>

          {/* <Form
            form={patientForm}
            autoComplete='off'
            colon={false}
            labelCol={{ flex: '5.625rem' }}
            className={styles.patient}
            style={{ marginRight: 20, marginTop: 10 }}
          >
            <Form.Item
              label='身高'
              name='patientHeight'
              rules={[
                {
                  message: '请输入整数值',
                  pattern: new RegExp(/^[0-9]+$/),
                },
              ]}
            >
              <Input suffix='cm' />
            </Form.Item>
            <Form.Item
              label='体重'
              name='patientWeight'
              rules={[
                {
                  message: '请输入最多带两位小数的数值',
                  pattern: new RegExp(/^[0-9]+((\.)[0-9]{0,2})?$/),
                },
              ]}
            >
              <Input suffix='kg' />
            </Form.Item>
            <Form.Item
              label='体温'
              name='patientTemperature'
              rules={[
                {
                  message: '请输入最多带一位小数的数值',
                  pattern: new RegExp(/^[0-9]+((\.)[0-9]?)?$/),
                },
              ]}
            >
              <Input suffix='℃' />
            </Form.Item>
            <Form.Item
              label='脉搏'
              name='patientPulse'
              rules={[
                {
                  message: '请输入整数值',
                  pattern: new RegExp(/^[0-9]+$/),
                },
              ]}
            >
              <Input suffix='次/分' />
            </Form.Item>
            <Form.Item
              label='收缩压'
              name='patientSystolicPressure'
              rules={[
                {
                  message: '请输入整数值',
                  pattern: new RegExp(/^[0-9]+$/),
                },
              ]}
            >
              <Input suffix='mmHg' />
            </Form.Item>
            <Form.Item
              label='舒张压'
              name='patientDiastolicPressure'
              rules={[
                {
                  message: '请输入整数值',
                  pattern: new RegExp(/^[0-9]+$/),
                },
              ]}
            >
              <Input suffix='mmHg' />
            </Form.Item>
          </Form> */}
          {/* <Label label='就诊信息' style={{ marginTop: 0, marginLeft: 20 }} />
          <Divider style={{ marginBottom: 0, color: theme.c3 }} />
          <Form
            form={treatmentForm}
            colon={false}
            labelCol={{ flex: '6.25rem' }}
            className={styles.doctor}
            style={{ marginTop: 10, marginRight: 10 }}
          >
            <Form.Item
              label='挂号医生'
              name='registrationDoctorName'
              rules={[{ max: 40 }]}
            >
              <Input disabled />
            </Form.Item>
            <Form.Item label='医生科室' name='treatmentDepartmentId'>
              <Select
                disabled={!isDoctorEditable}
                onChange={(v) => {
                  treatmentForm.setFieldsValue({
                    treatmentDoctorId: undefined,
                  })
                }}
              >
                {departments.map((d) => (
                  <Select.Option key={d.id} value={d.id}>
                    {d.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item
              label='接诊医生'
              name='treatmentDoctorId'
              rules={[
                {
                  required: true,
                  message: '接诊医生不能为空',
                },
              ]}
            >
              <Select disabled={!isDoctorEditable}>
                {doctors.map((d) => (
                  <Select.Option key={d.id} value={d.id}>
                    {d.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item label='就诊类型' name='treatmentCategory'>
              <Select
                autoFocus={isOpen}
                open={isOpen}
                onClick={() => {
                  setIsOpen(!isOpen)
                }}
                onBlur={() => {
                  setIsOpen(false)
                }}
                defaultValue={0}
              >
                {TreatmentCategories.map((c) => (
                  <Select.Option key={c} value={c}>
                    {getTreatmentCategoryName(c)}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
            <Row justify='center' style={{ paddingLeft: 10, marginTop: 20 }}>
              <Form.Item name='receiveTag' valuePropName='checked'>
                <Checkbox>是否复诊</Checkbox>
              </Form.Item>
              <Form.Item name='infectiousDisease' valuePropName='checked'>
                <Checkbox style={{ marginLeft: 10 }}>是否传染病</Checkbox>
              </Form.Item>
            </Row>
          </Form> */}
        </Col>
      </Row>
      {state == 1 ? (
        <></>
      ) : (
        <Row
          style={{
            width: '100%',
            height: '3.125rem',
            backgroundColor: '#fff',
            paddingRight: '40px',
          }}
          align='middle'
        >
          {notice && notice.recentlyTreatmentTime && (
            <div
              style={{
                marginLeft: 15,
                fontSize: '1rem',
                color: theme.e,
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
              }}
              onClick={() => {
                setTempType(true)
                setIsModalVisible(true)
              }}
            >
              最近就诊：
              {moment(notice.recentlyTreatmentTime).format('YYYY/MM/DD')}
              <Tooltip title={notice?.disease}>
                <span
                  style={{
                    marginLeft: 15,
                    maxWidth: 400,
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis',
                  }}
                >
                  疾病名称：{notice?.disease}
                </span>
              </Tooltip>
            </div>
          )}
          <div style={{ flex: 1 }} />
          <Space>
            {settledState ?
            <Button
             style={{
                height: 36,
                width: 140,
                fontSize: 20,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
              type='primary'
              ghost
              onClick={async () => {
               saveSubmit(1)
              }}
              loading={isCreating}
            >
              保存并返回
            </Button>:
            <></>}
            <Button
              type='primary'
              onClick={() => {
               saveSubmit()
              }}
              loading={isCreating}
              style={{
                height: 36,
                width: 140,
                fontSize: 20,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              去开处方
            </Button>
          </Space>
        </Row>
      )}
      <PrintTemplateModal
        templateCategory={PrintTemplateCategory.Zds}
        visible={isPrintModalVisible && !!treatment?.id}
        treatmentId={treatment?.id}
        onCancel={() => setIsPrintModalVisible(false)}
      />
      <SaveTemplateModal
        templates={templates?.filter((v) => v?.categoryName != '收藏')}
        medicalRecord={2}
        categoryName={
          templates.find((v) => v.id == selectedCategoryId)?.categoryName
        }
        detail={targetTemplate}
        visible={SaveTemplateModalVasible}
        onCancel={() => {
          setSaveTemplateModalVasible(false)
          setTargetTemplate(undefined)
        }}
        onSave={() => {
          setSaveTemplateModalVasible(false)
          setTargetTemplate(undefined)
          dispatch(getTempalteDetailList(selectedCategoryId))
            .then(unwrapResult)
            .then((details) => {
              setTemplateDetails({
                ...templateDetails,
                [selectedCategoryId]: details,
              })
            })
        }}
      />
      <Modal
        modalRender={(node: any) => <Draggable>{node}</Draggable>} // 使用自定义渲染函数
      ></Modal>
      <DraggableModal
        title='AI 辅诊'
        visible={aiLargeVisible}
        restore={restoreFlag}
        onMinisize={setRestoreFlag}
        onCancel={() => {
          setAiLargeVisible(false)
        }}
      >
        <AiTreatment
          setRestoreFlag={setRestoreFlag}
          setLargeVible={setAiLargeVisible}
          baseData={baseData}
          registrationId={registration?.id}
          treatmentBody={{
            registration: registrations,
            diagnosisForm: TcmCasesForm,
            treatmentForm: treatmentForm,
            diag: selectedDiseases
              .map((diag) => `${diag.name}(${diag.icds})`)
              .join(', '),
          }}
        />
      </DraggableModal>
      <Modal
        width={800}
        footer={null}
        title=''
        visible={isLookPicModalVisible}
        onOk={(v) => {
          setIsLookPicModalVisible(false)
        }}
        onCancel={(v) => {
          setIsLookPicModalVisible(false)
        }}
      >
        <div
          style={{
            maxHeight: '600px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column',
            marginTop: '40px',
          }}
        >
          <img src={lookPic} style={{ width: '500px' }}></img>
          <a
            style={{ marginTop: '20px' }}
            onClick={(v) => {
              if(lookPic.indexOf("hydhis.c")>=0){
                window.open(lookPic.replace('http:', 'https:'), '_blank')
              }else{
                window.open(lookPic, '_blank')
              }
            }}
          >
            下载
          </a>
        </div>
      </Modal>
      <Modal
        className={styles.history}
        width={1200}
        style={{ height: 720, maxHeight: 720, overflow: 'hidden' }}
        title='历史就诊信息'
        visible={isModalVisible}
        footer={null}
        onCancel={() => {
          treatmentsRef.current?.reset()
          setIsModalVisible(false)
        }}
        destroyOnClose
      >
        <Treatments
          medicalRecord={2}
          // showDiagnosis={false}
          ref={treatmentsRef}
          style={{ height: '100%' }}
          patientId={registration?.patientId}
          treatmentId={notice?.treatmentId}
          tempType={tempType}
          onCopyRecipe={(vs, tip) => {
            const params = vs as CopyRecipeParams
            setIsModalVisible(false)
            setIsCopyReciptModalVisible(true)
            setCopyRecipeFlag(true)
            setIsCopyReciptParam(params)
          }}
          onCopy={copyRecipe}
        />
      </Modal>

      <PreferencesSetModal //偏好设置
        tabNum={'2'}
        isModalVisible={preferencesSetShow}
        handleCancel={() => setiPreferencesSetShow(false)}
        onsubmit={() => {
          PreferencesSetChange && PreferencesSetChange()
          setiPreferencesSetShow(false)
        }}
      />
      <UploadModal
        uploadModalVisible={isUploadVisible}
        accept={'.png,.tiff,.jpg,.jpeg,bmp,.heic,.webp'}
        id={registration?.id || registrationId}
        uploadType={7}
        onCancel={() => {
          setIsUploadVisible(false)
        }}
        maxCount={10}
        onSubmit={(v, i, id) => {
          if (fileList.length + v.length > 10) {
            notification.info({
              message: '已达到最大上传数量，请先删除再上传！',
            })
            return
          }
          dispatch(deleteUploadFileList({ ids: id })).then(unwrapResult)
          setFileList([...fileList, ...v])
          setIsUploadVisible(false)
        }}
      />
      {/* 口腔病历引用病历及处方 */}
      <Modal
        visible={isCopyReciptModalVisible}
        footer={null}
        destroyOnClose
        className={styles.modal}
      >
        <div
          style={{
            padding: '32px',
            display: 'flex',
            alignItems: 'center',
            position: 'relative',
          }}
        >
          <InfoCircleOutlined
            style={{
              color: '#faad14',
              marginRight: '10px',
              fontSize: '22px',
            }}
          />
          <span style={{ fontWeight: 'bold', fontSize: '16px' }}>
            是否从处方复制价格？
          </span>
        </div>
        <CloseOutlined
          style={{
            position: 'absolute',
            color: '#8c8c8c',
            right: 10,
            top: 20,
            marginRight: '10px',
            fontSize: '22px',
          }}
          onClick={() => {
            setIsCopyReciptModalVisible(false)
            setcfBtnLoading(false)
            setmlBtnLoading(false)
            setkcBtnLoading(false)
          }}
        />
        <Row
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            marginTop: '20px',
          }}
        >
          <Button
            style={{
              marginRight: '14px',
            }}
            loading={mlBtnLoading}
            onClick={() => {
              setmlBtnLoading(true)
              setcfBtnLoading(true)
              setkcBtnLoading(true)
              if(copyRecipeFlag){
                if(treatment?.id){
                  dispatch(
                    copyTreatmentRecipe({
                      ...isCopyReciptParam,
                      treatmentId :treatment?.id,
                      copyAmountType: 1,
                    })
                  )
                    .then(unwrapResult)
                    .then(() => {
                      notification.success({
                        message: '复制成功',
                      })
                      setIsCopyReciptModalVisible(false)
                      getRefreshList(registrationId, treatmentId)
                    })
                    .catch((v) => {
                      setIsCopyReciptModalVisible(false)
                    })
                    .finally(() => {
                      setmlBtnLoading(false)
                      setcfBtnLoading(false)
                      setkcBtnLoading(false)
                    })
                    return
                }else{
                  notification.info({
                    message:'请先保存病历'
                  })
                  setIsCopyReciptModalVisible(false)
                  setmlBtnLoading(false)
                  setcfBtnLoading(false)
                  setkcBtnLoading(false)
                  return
                }
              }else{
                dispatch(
                copyTreatment({
                  ...isCopyReciptParam,
                  allergen: TcmCasesForm.getFieldValue('allergen'),
                  registrationId,
                  copyAmountType: 0,
                })
                )
                  .then(unwrapResult)
                  .then(() => {
                  setIsCopyReciptModalVisible(false)
                  notification.success({
                    message: '病历和处方已复制',
                  })
                  getRefreshList(
                    registrationId,
                    treatmentId,
                  )
                  })
                  .catch((v) => {
                    setIsCopyReciptModalVisible(false)
                  })
                  .finally(()=>{
                    setmlBtnLoading(false)
                    setcfBtnLoading(false)
                    setkcBtnLoading(false)
                  })
              }
            }}
          >
            使用目录价格
          </Button>
          <Button
            style={{
              marginRight: '14px',
            }}
            loading={cfBtnLoading}
            type='primary'
            onClick={() => {
              setmlBtnLoading(true)
              setcfBtnLoading(true)
              setkcBtnLoading(true)
              if(copyRecipeFlag){
                if(treatment?.id){
                  dispatch(
                    copyTreatmentRecipe({
                      ...isCopyReciptParam,
                      treatmentId :treatment?.id,
                      copyAmountType: 1,
                    })
                  )
                    .then(unwrapResult)
                    .then(() => {
                      notification.success({
                        message: '复制成功',
                      })
                      setIsCopyReciptModalVisible(false)
                      getRefreshList(registrationId, treatmentId)
                    })
                    .catch((v) => {
                      setIsCopyReciptModalVisible(false)
                    })
                    .finally(() => {
                      setmlBtnLoading(false)
                      setcfBtnLoading(false)
                      setkcBtnLoading(false)
                    })
                    return
                }else{
                  notification.info({
                    message:'请先保存病历'
                  })
                  setIsCopyReciptModalVisible(false)
                  setmlBtnLoading(false)
                  setcfBtnLoading(false)
                  setkcBtnLoading(false)
                  return
                }
              }else{
                dispatch(
                  copyTreatment({
                    ...isCopyReciptParam,
                    allergen: TcmCasesForm.getFieldValue('allergen'),
                    registrationId,
                    copyAmountType: 1,
                  })
                )
                  .then(unwrapResult)
                  .then(() => {
                    setIsCopyReciptModalVisible(false)
                    notification.success({
                      message: '病历和处方已复制',
                    })
                    getRefreshList( registrationId,treatmentId)
                  })
                  .catch((v) => {
                    setIsCopyReciptModalVisible(false)
                  })
                  .finally(()=>{
                    setmlBtnLoading(false)
                    setcfBtnLoading(false)
                    setkcBtnLoading(false)
                  })
              }
            }}
          >
            使用处方价格
          </Button>
          <Button
            style={{
              marginRight: '14px',
            }}
            loading={kcBtnLoading}
            type='primary'
            onClick={() => {
              setmlBtnLoading(true)
              setcfBtnLoading(true)
              setkcBtnLoading(true)
              if(copyRecipeFlag){
                if(treatment?.id){
                  dispatch(
                    copyTreatmentRecipe({
                      ...isCopyReciptParam,
                      treatmentId :treatment?.id,
                      copyAmountType: 1,
                    })
                  )
                    .then(unwrapResult)
                    .then(() => {
                      notification.success({
                        message: '复制成功',
                      })
                      setIsCopyReciptModalVisible(false)
                      getRefreshList(registrationId, treatmentId)
                    })
                    .catch((v) => {
                      setIsCopyReciptModalVisible(false)
                    })
                    .finally(() => {
                      setmlBtnLoading(false)
                      setcfBtnLoading(false)
                      setkcBtnLoading(false)
                    })
                    return
                }else{
                  notification.info({
                    message:'请先保存病历'
                  })
                  setIsCopyReciptModalVisible(false)
                  setmlBtnLoading(false)
                  setcfBtnLoading(false)
                  setkcBtnLoading(false)
                  return
                }
              }else{
                dispatch(
                copyTreatment({
                  ...isCopyReciptParam,
                  allergen: TcmCasesForm.getFieldValue('allergen'),
                  registrationId,
                  copyAmountType: 2,
                })
                )
                  .then(unwrapResult)
                  .then(() => {
                  setIsCopyReciptModalVisible(false)
                  notification.success({
                    message: '病历和处方已复制',
                  })
                  getRefreshList(registrationId,treatmentId)
                  })
                  .catch(() => {
                  setIsCopyReciptModalVisible(false)
                  })
                  .finally(()=>{
                    setmlBtnLoading(false)
                    setcfBtnLoading(false)
                    setkcBtnLoading(false)
                  })
              }
            }}
          >
            使用库存价格
          </Button>
        </Row>
      </Modal>
      <Modal
        title='温馨提醒'
        visible={isTipsModalVisible}
        width={700}
        footer={null}
        maskClosable={false}
        closable
        onOk={() => {
          setIsTipsModalVisible(false)
          form.resetFields()
          setInputValues({})
          setInputIcds({})
        }}
        onCancel={() => {
          setTimeout(() => {
            setIsTipsModalVisible(false)
          }, 300)
          form.resetFields()
          setInputValues({})
          setInputIcds({})
        }}
      >
        <Text>
          <div>该患者存在备案的特慢病信息，请搜索一个明确诊断，然后点击引用</div>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            {searchMedical?.map((v: any) => {
              const disease = {
                icds: v.diseaseCode,
                id: v.id,
                name: v.diseaseName,
              }
              return (
                <div
                  style={{
                    display: 'flex',
                    marginTop: '10px',
                    alignItems: 'center',
                  }}
                  key={v.icds}
                >
                  <span
                    style={{
                      width:'220px',
                      color: '#027AFF',
                      padding: '0 10px',
                      cursor: 'pointer',
                      textDecoration: 'underline',
                      fontWeight: 'bold',
                      marginRight: '10px',
                      display: 'flex',
                      justifyContent:'flex-end'
                    }}
                    key={v.icds}
                    onClick={() => {
                      // if (
                      //   !selectedDiseases.find((d) => d?.icds === disease?.icds)
                      // ) {
                      //   setSelectedDiseases(
                      //     selectedDiseases.concat(disease as Disease)
                      //   )
                      //   diseasesChose(v)
                      //   setIsTipsModalVisible(false)
                      // }
                    }}
                  >
                    {`${disease.name}/${disease.icds}`}
                  </span>
                  <div style={{ height: '30px' }}>
                    <Form form={form}>
                      <Form.Item name={`diagnosis-${disease.icds}`} label=''>
                        <Select
                          style={{ width: '330px' }}
                          showSearch
                          onClick={() => {
                            getDiseaseList(disease.icds,inputValues[disease.icds])
                          }}
                          onChange={((e)=>{
                            setInputValues((prev) => ({
                              ...prev,
                              [disease.icds]: e,
                            }))
                            setInputIcds((prev) => ({
                              ...prev,
                              [disease.icds]: disease.icds,
                            }))
                            getDiseaseList(disease.icds, e)
                          })}
                          onSearch={(e: any) => {
                            setInputValues((prev) => ({
                              ...prev,
                              [disease.icds]: e,
                            }))
                            setInputIcds((prev) => ({
                              ...prev,
                              [disease.icds]: disease.icds,
                            }))
                            getDiseaseList(disease.icds, e)
                          }}
                          onSelect={(v: any) => {
                            const name = v?.split('/')?.[0]
                            const icds = v?.split('/')?.[1]
                            handleOptionSelect(
                              disease.icds,
                              name,
                              icds
                            )
                          }}
                          filterOption={false}
                          optionFilterProp='children'
                          allowClear
                        >
                          {diseaseOptions?.[disease.icds]?.map((v: any) => {
                            return (
                              <Option value={v.diseaseName} key={v.diseaseName}>
                                {v.disName}/{v.icds}
                              </Option>
                            )
                          })}
                        </Select>
                      </Form.Item>
                    </Form>
                  </div>
                  <Button
                    type='primary'
                    size='small'
                    style={{ marginLeft: '20px' }}
                    onClick={() => {
                      const data: any = {
                        icds: inputIcds[disease.icds],
                        name: inputValues[disease.icds],
                        id: disease.id,
                      }
                      if(!inputValues[disease.icds]){
                        notification.info({
                          message:'请搜索一个明确诊断，然后点击引用'
                        })
                        return 
                      }
                        if (
                          !selectedDiseases.find(
                            (d) => d?.icds === inputIcds[disease?.icds]
                          )
                        ) {
                          setSelectedDiseases(selectedDiseases.concat(data)?.filter((v: any) => v?.name))
                          diseasesChose(v)
                        }
                        setIsTipsModalVisible(false)
                        form.resetFields()
                        setInputValues({})
                    }}
                  >
                    引用
                  </Button>
                </div>
              )
            })}
          </div>
        </Text>
        <Row justify='end' style={{ marginTop: '20px' }}>
          <Button
            onClick={() => {
              setIsTipsModalVisible(false)
              form.resetFields()
              setInputIcds({})
              setInputValues({})
            }}
            style={{ marginRight: '10px' }}
          >
            不引用
          </Button>
          <Button
            type='primary'
            onClick={() => {
              const data = searchMedical?.map((v: any) => {
                return {
                  icds: inputIcds[v.diseaseCode],
                  id: v.id,
                  name: inputValues[v.diseaseCode],
                }
              })
              const DiseaseList = mergeUniqueArrays(selectedDiseases, data)
              setSelectedDiseases(DiseaseList?.filter((v: any) => v?.name))
              diseasesChose(searchMedical?.[data?.length - 1])
              setIsTipsModalVisible(false)
              form.resetFields()
              setInputValues({})
              setInputIcds({})
            }}
          >
            全部引用
          </Button>
        </Row>
      </Modal>
      <ReplenishPatientModal
        isDiseaseEmpty={isDiseaseEmpty}
        patient={patient}
        visible={isReplenishPatientModalVisible}
        registrationId={registration?.id || registrationId}
        treatmentId={treatment?.id || treatmentId}
        onCancel={() => {
          setIsReplenishPatientModalVisible(false)
          TcmCasesForm.resetFields(['wmDiagFlag'])
        }}
        onOk={() => {
          setIsReplenishPatientModalVisible(false)
        }}
      />
    </div>
  )
}

export const TCMCases = forwardRef(TcmCases)
